import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Typography, Grid, Link } from "@mui/material";
import { withStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { v4 as uuidv4 } from "uuid";
import SwipeableViews from "react-swipeable-views";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import enLocale from "date-fns/locale/en-US";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Cookies from "js-cookie";
import Skeleton from "@mui/material/Skeleton";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useMediaQuery } from "@mui/material";
import debounce from "just-debounce-it";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

/* useCallback(debounce()) */

import {
  getBusqueda,
  getCapitulos,
  getSecciones,
  getFraccion,
  getPartida,
  getSubpartida,
  getNicos,
  getNotas,
  getDescripcion,
  getHistorico,
  getTLCs,
  getALADIs,
  getFranja,
  getProhibiciones,
  getIndicadores,
  getIndicadoresDos,
  getArancelPais,
  reiniciaBusqueda,
  getPermisos,
  getNoms,
  getCuotasCompensatorias,
  getImmex,
  getPromocionSectorial,
  getPreciosEstimados,
  getArancelCupo,
  getIva,
  getIsan,
  getIeps,
  getPacic,
  get_mercancia_peligrosa,
  get_control_de_exportaciones,
  get_medidas_de_transicion,
  get_deposito_fiscal,
  get_mercancias_vulnerables,
  get_vehiculos_usados,
  get_marcas_comerciales,
  get_anexo_7,
  get_anexo_8,
  get_anexo_9,
  get_anexo_29,
  get_anexo_10,
  get_anexo_12,
  get_anexo_14,
  get_anexo_17,
  get_anexo_21,
  get_anexo_28,
  get_anexo_21_dos,
  get_anexo_21_tres,
  getIsanDos,
  getPreciosEstimadosDos,
  getPreciosEstimadosTres,
  getCuposTLC,
  getNotasTLC,
  getCuposALADIDos,
  getCuposALADIUno,
  getCorrelativo,
} from "./../../../actions/landingActions";

import { getFormatoFecha } from "../../../utils/getFormatoFecha";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function findLastFriday(date) {
  // Obtenemos el día de la semana de la fecha dada
  const dayOfWeek = date.getDay();

  // Definimos el valor para un día en milisegundos
  const dayInMillis = 24 * 60 * 60 * 1000;

  // Restamos los días necesarios para llegar al viernes anterior
  const daysToSubtract = dayOfWeek === 6 ? 1 : dayOfWeek === 0 ? 2 : 3;
  const friday = new Date(date.getTime() - daysToSubtract * dayInMillis);

  return friday;
}

function romanize(num) {
  if (isNaN(num)) return NaN;
  var digits = String(+num).split(""),
    key = [
      "",
      "C",
      "CC",
      "CCC",
      "CD",
      "D",
      "DC",
      "DCC",
      "DCCC",
      "CM",
      "",
      "X",
      "XX",
      "XXX",
      "XL",
      "L",
      "LX",
      "LXX",
      "LXXX",
      "XC",
      "",
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
      "IX",
    ],
    roman = "",
    i = 3;
  while (i--) roman = (key[+digits.pop() + i * 10] || "") + roman;
  return Array(+digits.join("") + 1).join("M") + roman;
}

function validarFecha(fechaString) {
  const fecha = new Date(fechaString);
  return !isNaN(fecha.getTime());
}

var reg = /^\d+$/;

var regBusqueda = /^[A-Za-z0-9\.]+$/;

var regAladi = /-A|-B|-C/g;

function Nico(props) {
  const { nico, idioma, fechaTabla } = props;
  return (
    <TableRow hover={true} sx={{ cursor: "pointer" }}>
      <TableCell></TableCell>
      <TableCell sx={{ fontWeight: "bold" }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <IconButton
            color="primary"
            aria-label="upload picture"
            component="label"
          >
            <Link
              href={`${window.location.href.substring(
                0,
                window.location.href.indexOf("/", 10)
              )}?hs=${nico.Fraccion}&date=${fechaTabla.toLocaleDateString(
                "en-US"
              )}`}
              target="_blank"
              rel="noopener"
              color="inherit"
              underline="none"
            >
              <OpenInNewIcon />
            </Link>
          </IconButton>
          <Typography noWrap={true} variant="subtitle2" fontWeight="bold">
            {nico.Fraccion}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell>{nico.Descripcion}</TableCell>
      <TableCell>
        <Typography noWrap={true} variant="subtitle2">
          {getFormatoFecha(nico.Fecha_publicacion, idioma)}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

function Fraccion(props) {
  const {
    fraccion,
    getNicos,
    nicos,
    notas,
    getNotas,
    periodo,
    idioma,
    messages,
    fechaTabla,
  } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        sx={{
          cursor: "pointer",
        }}
        hover={true}
      >
        <TableCell>
          {fraccion.Nico ? (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={(e) => {
                setOpen(!open);
                if (
                  nicos.length === 0 ||
                  nicos.filter(
                    (nico) =>
                      nico.Fraccion.substring(0, 8) === fraccion.Fraccion
                  ).length === 0
                )
                  getNicos({
                    texto: fraccion.Fraccion,
                    periodo: periodo.toLocaleDateString("en-US"),
                    idioma: idioma,
                  });

                if (
                  notas.filter((nota) => nota.Clave === fraccion.Fraccion)
                    .length === 0
                ) {
                  getNotas({
                    texto: fraccion.Fraccion,
                    periodo: periodo.toLocaleDateString("en-US"),
                    tipo: "1",
                  });
                }
              }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          ) : (
            ""
          )}
        </TableCell>
        <TableCell sx={{ fontWeight: "bold" }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="label"
            >
              <Link
                href={`${window.location.href.substring(
                  0,
                  window.location.href.indexOf("/", 10)
                )}?hs=${fraccion.Fraccion}&date=${fechaTabla.toLocaleDateString(
                  "en-US"
                )}`}
                target="_blank"
                rel="noopener"
                color="inherit"
                underline="none"
              >
                <OpenInNewIcon />
              </Link>
            </IconButton>
            <Typography noWrap={true} variant="subtitle2" fontWeight="bold">
              {fraccion.Fraccion}
            </Typography>
          </Stack>
        </TableCell>
        <TableCell>{fraccion.Descripcion}</TableCell>
        <TableCell>{fraccion.Descripcion_es}</TableCell>
        <TableCell>{fraccion.IGI}</TableCell>
        <TableCell>{fraccion.IGE}</TableCell>
        <TableCell>
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(fraccion.Fecha_publicacion, idioma)}
          </Typography>
        </TableCell>
      </TableRow>

      <TableRow hover={true}>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, borderBottom: "none" }}
          colSpan={7}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, marginLeft: "5%" }}>
              {/*               <Typography variant="h6" gutterBottom component="div">
                History
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead sx={{ backgroundColor: "#0D3D66" }} className="no">
                  <TableRow>
                    <TableCell />
                    <TableCell sx={{ color: "#fff" }} align="center">
                      NICOS
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {messages.descripcion}
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {messages.publicado}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="no">
                  {nicos.length === 0 ||
                  nicos.filter(
                    (nico) =>
                      nico.Fraccion.substring(0, 8) === fraccion.Fraccion
                  ).length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                      </TableCell>
                    </TableRow>
                  ) : (
                    nicos
                      .filter(
                        (nico) =>
                          nico.Fraccion.substring(0, 8) === fraccion.Fraccion
                      )
                      .map((nico, i) => (
                        <Nico
                          key={i}
                          nico={nico}
                          idioma={idioma}
                          fechaTabla={fechaTabla}
                        ></Nico>
                      ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      {open &&
      notas.filter((nota) => nota.Clave === fraccion.Fraccion).length > 0 ? (
        <TableRow>
          <TableCell colSpan={3}>
            <div
              style={{
                padding: "0 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
              }}
              dangerouslySetInnerHTML={{
                __html: notas.filter(
                  (nota) => nota.Clave === fraccion.Fraccion
                )[0].Notas,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function Subpartida(props) {
  const {
    getFraccion,
    fracciones,
    subpartida,
    getNicos,
    nicos,
    notas,
    getNotas,
    periodo,
    idioma,
    messages,
    fechaTabla,
  } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow hover={true}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
              if (
                fracciones.length === 0 ||
                fracciones.filter(
                  (fraccion) =>
                    fraccion.Fraccion.substring(0, 6) === subpartida.Fraccion
                ).length === 0
              )
                getFraccion({
                  texto: subpartida.Fraccion,
                  periodo: periodo.toLocaleDateString("en-US"),
                  idioma: idioma,
                });

              if (
                notas.filter((nota) => nota.Clave === subpartida.Fraccion)
                  .length === 0
              ) {
                getNotas({
                  texto: subpartida.Fraccion,
                  periodo: periodo.toLocaleDateString("en-US"),
                  tipo: "1",
                });
              }
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          {subpartida.Subcapitulo ? "" : subpartida.Fraccion}
        </TableCell>
        <TableCell>
          <Typography variant="subtitle2">
            {subpartida.Subcapitulo
              ? subpartida.Subcapitulo_es
              : "- ".repeat(subpartida.Numero_guiones) + subpartida.Descripcion}
          </Typography>

          {subpartida.Subcapitulo ? (
            <Typography variant="subtitle2">
              <strong>{subpartida.Fraccion}</strong>{" "}
              {"- ".repeat(subpartida.Numero_guiones) + subpartida.Descripcion}
            </Typography>
          ) : (
            ""
          )}
        </TableCell>
        <TableCell>
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(subpartida.Fecha_publicacion, idioma)}
          </Typography>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, borderBottom: "none" }}
          colSpan={3}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, marginLeft: "5%" }}>
              {/*               <Typography variant="h6" gutterBottom component="div">
                History
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead sx={{ backgroundColor: "#1e88e5" }} className="no">
                  <TableRow>
                    <TableCell />
                    <TableCell sx={{ color: "#fff" }} align="center">
                      {messages.fraccion}
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {messages.descripcion}
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {messages.unidad_de_medida}
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>IGI</TableCell>
                    <TableCell sx={{ color: "#fff" }}>IGE</TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {messages.publicado}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="no">
                  {fracciones.length === 0 ||
                  fracciones.filter(
                    (fraccion) =>
                      fraccion.Fraccion.substring(0, 6) === subpartida.Fraccion
                  ).length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7}>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                      </TableCell>
                    </TableRow>
                  ) : (
                    fracciones
                      .filter(
                        (fraccion) =>
                          fraccion.Fraccion.substring(0, 6) ===
                          subpartida.Fraccion
                      )
                      .map((fraccion, i) => (
                        <Fraccion
                          key={i}
                          fraccion={fraccion}
                          getNicos={getNicos}
                          nicos={nicos}
                          notas={notas}
                          getNotas={getNotas}
                          periodo={periodo}
                          idioma={idioma}
                          messages={messages}
                          fechaTabla={fechaTabla}
                        ></Fraccion>
                      ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      {open &&
      notas.filter((nota) => nota.Clave === subpartida.Fraccion).length > 0 ? (
        <TableRow>
          <TableCell colSpan={3}>
            <div
              style={{
                padding: "0 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
              }}
              dangerouslySetInnerHTML={{
                __html: notas.filter(
                  (nota) => nota.Clave === subpartida.Fraccion
                )[0].Notas,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function Partida(props) {
  const {
    partida,
    getSubpartida,
    subpartidas,
    getFraccion,
    fracciones,
    nicos,
    getNicos,
    notas,
    getNotas,
    periodo,
    idioma,
    messages,
    fechaTabla,
  } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow hover={true}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
              if (
                subpartidas.length === 0 ||
                subpartidas.filter(
                  (subpartida) =>
                    subpartida.Fraccion.substring(0, 4) === partida.Fraccion
                ).length === 0
              )
                getSubpartida({
                  texto: partida.Fraccion,
                  periodo: periodo.toLocaleDateString("en-US"),
                  idioma: idioma,
                });

              if (
                notas.filter((nota) => nota.Clave === partida.Fraccion)
                  .length === 0
              ) {
                getNotas({
                  texto: partida.Fraccion,
                  periodo: periodo.toLocaleDateString("en-US"),
                  tipo: "1",
                });
              }
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center">
          {partida.Subcapitulo ? "" : partida.Fraccion}
        </TableCell>
        <TableCell>
          <Typography variant="subtitle2">
            {partida.Subcapitulo ? partida.Subcapitulo_es : partida.Descripcion}
          </Typography>

          {partida.Subcapitulo ? (
            <Typography variant="subtitle2">
              <strong>{partida.Fraccion}</strong> {partida.Descripcion}
            </Typography>
          ) : (
            ""
          )}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, borderBottom: "none" }}
          colSpan={3}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, marginLeft: "5%" }}>
              {/*               <Typography variant="h6" gutterBottom component="div">
                History
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead sx={{ backgroundColor: "#E7EBF0" }}>
                  <TableRow>
                    <TableCell />
                    <TableCell>SubPartida</TableCell>
                    <TableCell>{messages.descripcion}</TableCell>
                    <TableCell>{messages.publicado}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="no">
                  {subpartidas.length === 0 ||
                  subpartidas.filter(
                    (subpartida) =>
                      subpartida.Fraccion.substring(0, 4) === partida.Fraccion
                  ).length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                      </TableCell>
                    </TableRow>
                  ) : (
                    subpartidas
                      .filter(
                        (subpartida) =>
                          subpartida.Fraccion.substring(0, 4) ===
                          partida.Fraccion
                      )
                      .map((subpartida, i) => (
                        <Subpartida
                          key={i}
                          subpartida={subpartida}
                          getFraccion={getFraccion}
                          fracciones={fracciones}
                          nicos={nicos}
                          getNicos={getNicos}
                          notas={notas}
                          getNotas={getNotas}
                          periodo={periodo}
                          idioma={idioma}
                          messages={messages}
                          fechaTabla={fechaTabla}
                        ></Subpartida>
                      ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      {open &&
      notas.filter((nota) => nota.Clave === partida.Fraccion).length > 0 ? (
        <TableRow>
          <TableCell colSpan={3}>
            <div
              style={{
                padding: "0 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
              }}
              dangerouslySetInnerHTML={{
                __html: notas.filter(
                  (nota) => nota.Clave === partida.Fraccion
                )[0].Notas,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function Capitulo(props) {
  const {
    capitulo,
    getPartida,
    partidas,
    subpartidas,
    fracciones,
    getSubpartida,
    getFraccion,
    nicos,
    getNicos,
    notas,
    getNotas,
    periodo,
    idioma,
    messages,
    fechaTabla,
  } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow hover={true}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
              if (
                partidas.length === 0 ||
                partidas.filter(
                  (partida) =>
                    partida.Fraccion.substring(0, 2) === capitulo.Busqueda
                ).length === 0
              )
                getPartida({
                  texto: capitulo.Busqueda,
                  periodo: periodo.toLocaleDateString("en-US"),
                  idioma: idioma,
                });

              if (
                notas.filter((nota) => nota.Clave === "C" + capitulo.Capitulo)
                  .length === 0
              ) {
                getNotas({
                  texto: "C" + capitulo.Capitulo,
                  periodo: periodo.toLocaleDateString("en-US"),
                  tipo: "1",
                });
              }
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center">{capitulo.Busqueda}</TableCell>
        <TableCell>
          {idioma === "es-MX"
            ? capitulo.Descripcion_es
            : capitulo.Descripcion_en}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, borderBottom: "none" }}
          colSpan={3}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, marginLeft: "5%" }}>
              {/*               <Typography variant="h6" gutterBottom component="div">
                History
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead sx={{ backgroundColor: "#E7EBF0" }}>
                  <TableRow>
                    <TableCell />
                    <TableCell>Partida</TableCell>
                    <TableCell>{messages.descripcion}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="no">
                  {partidas.length === 0 ||
                  partidas.filter(
                    (partida) =>
                      partida.Fraccion.substring(0, 2) === capitulo.Busqueda
                  ).length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "30px", margin: "5px 0px" }}
                        />
                      </TableCell>
                    </TableRow>
                  ) : (
                    partidas
                      .filter(
                        (partida) =>
                          partida.Fraccion.substring(0, 2) === capitulo.Busqueda
                      )
                      .map((partida, i) => (
                        <Partida
                          key={i}
                          partida={partida}
                          getSubpartida={getSubpartida}
                          subpartidas={subpartidas}
                          fracciones={fracciones}
                          getFraccion={getFraccion}
                          getNicos={getNicos}
                          nicos={nicos}
                          notas={notas}
                          getNotas={getNotas}
                          periodo={periodo}
                          idioma={idioma}
                          messages={messages}
                          fechaTabla={fechaTabla}
                        ></Partida>
                      ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      {open &&
      notas.filter((nota) => nota.Clave === "C" + capitulo.Capitulo).length >
        0 ? (
        <TableRow>
          <TableCell colSpan={3}>
            <div
              style={{
                padding: "0 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
              }}
              dangerouslySetInnerHTML={{
                __html: notas.filter(
                  (nota) => nota.Clave === "C" + capitulo.Capitulo
                )[0].Notas,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function Row(props) {
  const {
    row,
    capitulos,
    partidas,
    subpartidas,
    fracciones,
    getPartida,
    getSubpartida,
    getFraccion,
    getNicos,
    getNotas,
    nicos,
    notas,
    periodo,
    idioma,
    messages,
    fechaTabla,
  } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow hover={true}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
              if (
                notas.length === 0 ||
                notas.filter((nota) => nota.Clave === "S" + row.Seccion)
                  .length === 0
              )
                getNotas({
                  texto: "S" + row.Seccion,
                  periodo: periodo.toLocaleDateString("en-US"),
                  tipo: "1",
                });
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          <Typography noWrap={true}>
            {messages.seccion} {romanize(row.Seccion)}
          </Typography>
        </TableCell>
        <TableCell align="left">
          {idioma === "es-MX" ? row.Descripcion_es : row.Descripcion_en}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, borderBottom: "none" }}
          colSpan={3}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, marginLeft: "5%" }}>
              {/*               <Typography variant="h6" gutterBottom component="div">
                History
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead sx={{ backgroundColor: "#E7EBF0" }}>
                  <TableRow>
                    <TableCell />
                    <TableCell align="center">{messages.capitulo}</TableCell>
                    <TableCell>{messages.descripcion}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="no">
                  {capitulos.map((capitulo, i) => (
                    <Capitulo
                      key={i}
                      capitulo={capitulo}
                      getPartida={getPartida}
                      getSubpartida={getSubpartida}
                      getFraccion={getFraccion}
                      partidas={partidas}
                      subpartidas={subpartidas}
                      fracciones={fracciones}
                      nicos={nicos}
                      getNicos={getNicos}
                      notas={notas}
                      getNotas={getNotas}
                      periodo={periodo}
                      idioma={idioma}
                      messages={messages}
                      fechaTabla={fechaTabla}
                    ></Capitulo>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      {notas.length > 0 &&
      open &&
      notas.filter((nota) => nota.Clave === "S" + row.Seccion).length > 0 ? (
        <TableRow>
          <TableCell colSpan={3}>
            <div
              style={{
                padding: "0 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
              }}
              dangerouslySetInnerHTML={{
                __html: notas.filter(
                  (nota) => nota.Clave === "S" + row.Seccion
                )[0].Notas,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

/* Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};
 */

function RowDescripcion(props) {
  const { row, getNotas, notas, periodo } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow hover={true}>
        <TableCell>
          {row.Nota ? (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={(e) => {
                setOpen(!open);
                if (
                  notas.length === 0 ||
                  notas.filter((nota) => nota.Clave === row.Clave).length === 0
                )
                  getNotas({
                    texto: row.Clave,
                    periodo: periodo.toLocaleDateString("en-US"),
                    tipo: "1",
                  });
              }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          ) : (
            ""
          )}
        </TableCell>
        <TableCell align="left">{row.Tipo}</TableCell>
        <TableCell component="th" scope="row">
          <Typography variant="subtitle2" noWrap={true}>
            {row.Tipo === "Seccion"
              ? romanize(row.Codigo)
              : row.Subcapitulo
              ? ""
              : row.Codigo}
          </Typography>
        </TableCell>

        <TableCell align="left">
          <Typography variant="subtitle2">
            {row.Subcapitulo
              ? row.Subcapitulo_es
              : `${"- ".repeat(row.guiones)} ${row.Descripcion_es}`}
          </Typography>

          {row.Subcapitulo ? (
            <Typography variant="subtitle2">
              <strong>{row.Codigo}</strong>{" "}
              {`${"- ".repeat(row.guiones)} ${row.Descripcion_es}`}
            </Typography>
          ) : (
            ""
          )}
        </TableCell>
      </TableRow>

      {notas.length > 0 &&
      open &&
      notas.filter((nota) => nota.Clave === row.Clave).length > 0 ? (
        <TableRow>
          <TableCell colSpan={4}>
            <div
              style={{
                padding: "0 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
              }}
              dangerouslySetInnerHTML={{
                __html: notas.filter((nota) => nota.Clave === row.Clave)[0]
                  .Notas,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowTLCs(props) {
  const {
    row,
    setTlcSeleccionado,
    tlcSeleccionado,
    i,
    handleOpenCupos,
    handleOpenNotas,
    getCuposTLC,
    getNotasTLC,
    fraccion,
    fecha,
    setCupoHeader,
    idioma,
  } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setTlcSeleccionado(i);
          if (!row.Nota) setOpen(!open);
        }}
        selected={i === tlcSeleccionado}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>
          <img
            style={{ height: "20px", width: "30px", marginRight: "10px" }}
            src={`${process.env.PUBLIC_URL}/images/paises/${row.Pais}.gif`}
            alt={row.Nombre}
          />
          {row.Nombre}
        </TableCell>
        <TableCell align="center">{row.Arancel}</TableCell>
        <TableCell align="center">{row.Unicamente}</TableCell>
        <TableCell align="center">
          {row.Nota ? (
            <Button
              variant="outlined"
              onClick={() => {
                handleOpenNotas();
                getNotasTLC({
                  fraccion: fraccion,
                  nota: row.Nota,
                  fecha: fecha,
                  tlc: row.TLC,
                });
              }}
            >
              {row.Nota}
            </Button>
          ) : (
            ""
          )}
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Hasta, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          {row.Cupo && row.Cupo === "s" ? (
            <Button
              variant="outlined"
              onClick={() => {
                handleOpenCupos();
                getCuposTLC({
                  fraccion: fraccion,
                  pais: row.Pais,
                  fecha: fecha,
                  tlc: row.TLC,
                });
                setCupoHeader({
                  fraccion: fraccion,
                  pais: row.Nombre,
                  tlc: row.Descripcion,
                });
              }}
            >
              Cupos
            </Button>
          ) : (
            ""
          )}
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={9}>
            <Typography noWrap={true} variant="h5" sx={{ margin: "20px" }}>
              {row.Descripcion}
            </Typography>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowAladi(props) {
  const {
    row,
    setAladiSeleccionado,
    aladiSeleccionado,
    i,
    handleOpenCuposALADI,
    getCuposALADIUno,
    getCuposALADIDos,
    setCupoHeaderALADI,
    fraccion,
    fecha,
    idioma,
  } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setAladiSeleccionado(i);
          if (row.Cupo === "n") setOpen(!open);
        }}
        selected={i === aladiSeleccionado}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>
          <img
            style={{ height: "20px", width: "30px", marginRight: "10px" }}
            src={`${process.env.PUBLIC_URL}/images/paises/${row.Pais}.gif`}
            alt={row.Nombre}
          />
          {row.Nombre}
        </TableCell>
        <TableCell align="center">{row.Arancel}</TableCell>
        <TableCell align="center">{row.Unicamente}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Hasta, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          {row.Articulo.match(regAladi) &&
          row.Articulo.match(regAladi).length > 0
            ? row.Clave + row.Articulo.match(regAladi)[0]
            : row.Clave}
        </TableCell>
        <TableCell align="center">
          {row.Cupo && row.Cupo === "s" ? (
            <Button
              variant="outlined"
              onClick={() => {
                handleOpenCuposALADI();
                getCuposALADIUno({
                  fraccion: fraccion,
                  pais: row.Pais,
                  fecha: fecha,
                  tlc:
                    row.Articulo.match(regAladi) &&
                    row.Articulo.match(regAladi).length > 0
                      ? row.Clave + row.Articulo.match(regAladi)[0]
                      : row.Clave,
                });
                getCuposALADIDos({
                  fraccion: fraccion,
                  pais: row.Pais,
                  fecha: fecha,
                  tlc:
                    row.Articulo.match(regAladi) &&
                    row.Articulo.match(regAladi).length > 0
                      ? row.Clave + row.Articulo.match(regAladi)[0]
                      : row.Clave,
                });
                setCupoHeaderALADI({
                  fraccion: fraccion,
                  pais: row.Nombre,
                  tlc: row.Descripcion,
                });
              }}
            >
              Cupos
            </Button>
          ) : (
            ""
          )}
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={9}>
            <Typography noWrap={true} variant="h5" sx={{ margin: "20px" }}>
              {row.Descripcion}
            </Typography>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowFranja(props) {
  const { row, i, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell align="center">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell align="center">{row.Arancel}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.VigenciaHasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={8}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginTop: "25px",
                marginBottom: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowProhibicion(props) {
  const { row, i, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>
          <img
            style={{ height: "20px", width: "30px", marginRight: "10px" }}
            src={`${process.env.PUBLIC_URL}/images/paises/${row.Pais}.gif`}
            alt={row.Nombre}
          />
          {row.Nombre}
        </TableCell>
        <TableCell align="center">{row.Fraccion}</TableCell>
        <TableCell align="center">{row.Unicamente}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Hasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={8}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowArancel(props) {
  const { row, i, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>
          <img
            style={{ height: "20px", width: "30px", marginRight: "10px" }}
            src={`${process.env.PUBLIC_URL}/images/paises/${row.Pais}.gif`}
            alt={row.Nombre}
          />
          {row.Nombre}
        </TableCell>
        <TableCell align="center">IGI: {row.IGI}</TableCell>
        <TableCell align="center">{row.Unicamente}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Desde, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Hasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={8}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowPermisos(props) {
  const { row, i, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>{row.Unicamente}</TableCell>
        <TableCell align="center">{row.Secretaria}</TableCell>
        <TableCell align="center">{row.PermisoM3}</TableCell>
        <TableCell align="center">{row.Descripcion}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.VigenciaHasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={8}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowNoms(props) {
  const { row, i, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>{row.NOM}</TableCell>
        <TableCell align="center">{row.Unicamente}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.VigenciaHasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={8}>
            <Typography variant="h5" sx={{ padding: "15px 20px 0px 20px" }}>
              {row.NOM}
            </Typography>

            <Typography variant="h5" sx={{ padding: "15px 20px" }}>
              <a target="_blank" rel="noopener noreferrer" href={row.Liga}>
                {row.Titulo}
              </a>
            </Typography>

            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowCuotasCompensatorias(props) {
  const { row, i, idioma } = props;
  const [open, setOpen] = React.useState(true);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>
          <img
            style={{ height: "20px", width: "30px", marginRight: "10px" }}
            src={`${process.env.PUBLIC_URL}/images/paises/${row.Pais}.gif`}
            alt={row.Nombre}
          />
          {row.Nombre}
        </TableCell>
        <TableCell align="center">{row.Producto}</TableCell>
        <TableCell align="center">{row.Empresa}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Hasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Cuota && open ? (
        <TableRow>
          <TableCell align="center" colSpan={8}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Cuota,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowImmex(props) {
  const { row, i, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>{row.Anexo}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Desde, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Hasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={8}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowPromocionSectorial(props) {
  const { row, i, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>{`${romanize(row.Sector)} ${row.Titulo}`}</TableCell>
        <TableCell align="center">{row.Inciso}</TableCell>
        <TableCell align="center">{row.Arancel}</TableCell>
        <TableCell align="center">{row.Unicamente}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.VigenciaHasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={8}>
            <Typography variant="h5" sx={{ padding: "15px 20px" }}>
              {`${romanize(row.Sector)} ${row.Titulo}`}
            </Typography>

            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowPreciosEstimados(props) {
  const { row, i, idioma, messages } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>{row.Unidad}</TableCell>
        <TableCell align="center">{row.Precio}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Desde, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Hasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={8}>
            <Typography variant="h5" sx={{ padding: "15px 20px" }}>
              {row.Titulo}
            </Typography>

            <Typography variant="h5" sx={{ padding: "0px 20px 15px 20px" }}>
              {`${messages.publicado}: ${getFormatoFecha(
                row.DecretoPublicado,
                idioma
              )}`}
            </Typography>

            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowArancelCupo(props) {
  const { row, i, j, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>{`${i + 1} de ${j}`}</TableCell>
        <TableCell align="center">{row.Unicamente}</TableCell>
        <TableCell align="center">{row.Unidad}</TableCell>
        <TableCell align="center">{row.UnidadM3}</TableCell>
        <TableCell align="center">{row.Arancel}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.VigenciaHasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={9}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowMedidasTransicion(props) {
  const { row, i, j, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>
          <img
            style={{ height: "20px", width: "30px", marginRight: "10px" }}
            src={`${process.env.PUBLIC_URL}/images/paises/${row.Pais}.gif`}
            alt={row.Nombre}
          />
          {row.Nombre}
        </TableCell>

        <TableCell align="center">{row.MedTran}</TableCell>
        <TableCell align="center">{row.Notas}</TableCell>
        <TableCell align="center">{row.ValorMinimo}</TableCell>
        <TableCell align="center">{row.NotasVM}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Desde, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Hasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Articulo && open ? (
        <TableRow>
          <TableCell align="center" colSpan={9}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Articulo,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowControlDeExportaciones(props) {
  const { row, i, j, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell align="center">{romanize(row.Anexo)}</TableCell>
        <TableCell align="center">
          <div
            style={{
              padding: "15px 15px",
              borderBottom: "none",
              backgroundColor: "rgba(242, 242, 242, 0)",
              maxHeight: "300px",
              overflow: "auto",
              textAlign: "justify",
              marginBottom: "25px",
              marginTop: "25px",
            }}
            dangerouslySetInnerHTML={{
              __html: row.Texto && row.Texto.length > 0 ? row.Texto[0] : "",
            }}
          />
        </TableCell>

        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Desde, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Hasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={9}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />

            {row.Texto && row.Texto.length > 1 ? (
              <div
                style={{
                  padding: "25px 100px",
                  borderBottom: "none",
                  backgroundColor: "rgba(242, 242, 242, 1)",
                  maxHeight: "300px",
                  overflow: "auto",
                  textAlign: "justify",
                  marginBottom: "25px",
                  marginTop: "25px",
                }}
                dangerouslySetInnerHTML={{
                  __html: row.Texto[1],
                }}
              />
            ) : (
              ""
            )}
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function RowVehiculosUsados(props) {
  const { row, i, j, idioma } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        hover={true}
        onClick={(a) => {
          setOpen(!open);
        }}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>{`${i + 1} de ${j}`}</TableCell>
        <TableCell align="center">{row.Unicamente}</TableCell>
        <TableCell align="center">{row.Unidad}</TableCell>
        <TableCell align="center">{row.UnidadM3}</TableCell>
        <TableCell align="center">{row.Arancel}</TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Publicado, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.Vigencia, idioma)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography noWrap={true} variant="subtitle2">
            {getFormatoFecha(row.VigenciaHasta, idioma)}
          </Typography>
        </TableCell>
      </TableRow>
      {row.Decreto && open ? (
        <TableRow>
          <TableCell align="center" colSpan={9}>
            <div
              style={{
                padding: "25px 100px",
                borderBottom: "none",
                backgroundColor: "rgba(242, 242, 242, 1)",
                maxHeight: "300px",
                overflow: "auto",
                textAlign: "justify",
                marginBottom: "25px",
                marginTop: "25px",
              }}
              dangerouslySetInnerHTML={{
                __html: row.Decreto,
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const styles = (theme) => ({
  titulo: {
    fontSize: "4rem !important",
    lineHeight: "1 !important",
    fontWeight: "700 !important",
    fontFamily: "Barlow",

    [theme.breakpoints.down("md")]: {
      fontSize: "3rem !important",
    },
  },

  textAlignTxt: {
    textAlign: "center !important",
  },

  cardServicios: {
    textAlign: "center",
    textDecoration: "none",
    marginLeft: "auto !important",
    marginRight: "auto !important",
  },

  cardQuienes: {
    textAlign: "center",
    textDecoration: "none",
    marginLeft: "auto",
    marginRight: "auto",
    placeItems: "center",
    minHeight: "300px",
  },
  corazon: {
    display: "block",
  },

  cardQuienesDos: {
    textAlign: "justify",
    minHeight: "300px",
    paddingLeft: "2%",
    paddingRight: "2%",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px !important",
    },
  },

  boxContainer: {
    backgroundColor: "rgb(245, 248, 250)",
    padding: "50px 24px",
    [theme.breakpoints.down("sm")]: {
      padding: "50px 10px",
    },
  },

  inputBusqueda: {
    textAlign: "center !important",
  },
});

function Tarifa(props) {
  const {
    classes,
    theme,
    servicios,
    getBusqueda,
    landing,
    getCapitulos,
    getSecciones,
    getPartida,
    getFraccion,
    getSubpartida,
    getNicos,
    getNotas,
    getDescripcion,
    getHistorico,
    getTLCs,
    getALADIs,
    getFranja,
    getProhibiciones,
    getIndicadores,
    getIndicadoresDos,
    getArancelPais,
    reiniciaBusqueda,
    getPermisos,
    getNoms,
    getCuotasCompensatorias,
    getImmex,
    getPromocionSectorial,
    getPreciosEstimados,
    getArancelCupo,
    getIva,
    getIsan,
    getIeps,
    getPacic,
    get_mercancia_peligrosa,
    get_control_de_exportaciones,
    get_medidas_de_transicion,
    get_deposito_fiscal,
    get_mercancias_vulnerables,
    get_vehiculos_usados,
    get_marcas_comerciales,
    get_anexo_7,
    get_anexo_8,
    get_anexo_9,
    get_anexo_29,
    get_anexo_10,
    get_anexo_12,
    get_anexo_14,
    get_anexo_17,
    get_anexo_21,
    get_anexo_28,
    get_anexo_21_dos,
    get_anexo_21_tres,
    getIsanDos,
    getPreciosEstimadosDos,
    getPreciosEstimadosTres,
    getCuposTLC,
    getNotasTLC,
    getCuposALADIDos,
    getCuposALADIUno,
    idioma,
    getCorrelativo,
    handleScrollClick,
    messages,
    pushMessageToSnackbar,
  } = props;
  const searchParams = new URLSearchParams(window.location.search);

  const [valueConsulta, setValueConsulta] = React.useState(0);
  const [value, setValue] = React.useState(0);
  const [tarifa, setTarifa] = React.useState("1");
  const [partidaSeleccionada, setPartidaSeleccionada] = React.useState();

  const [cupoAladiNota, setCupoAladiNota] = React.useState(0);

  const [cupoHeader, setCupoHeader] = React.useState();
  const [cupoHeaderALADI, setCupoHeaderALADI] = React.useState();

  const [openNotas, setOpenNotas] = React.useState(false);
  const [openSTPS, setOpenSTPS] = React.useState(false);
  const [openCupos, setOpenCupos] = React.useState(false);
  const [openCuposALADI, setOpenCuposALADI] = React.useState(false);

  const [fecha, setFecha] = React.useState(new Date());
  const [fechaPrevia, setFechaPrevia] = React.useState(new Date());

  const [fechaCorrelativo, setFechaCorrelativo] = React.useState();
  const [fechaTabla, setFechaTabla] = React.useState(new Date());
  const [session, setSession] = React.useState();

  const [tlcSeleccionado, setTlcSeleccionado] = React.useState("");
  const [aladiSeleccionado, setAladiSeleccionado] = React.useState("");
  const [paisSeleccionado, setPaisSeleccionado] = React.useState("");
  const [paisSeleccionadoAladi, setPaisSeleccionadoAladi] = React.useState("");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [pageAladi, setPageAladi] = React.useState(0);
  const [rowsPerPageAladi, setRowsPerPageAladi] = React.useState(10);

  const isShort = useMediaQuery("(max-width: 1000px)");

  const handleOpenCuposALADI = () => {
    setOpenCuposALADI(true);
  };

  useEffect(() => {
    if (fechaCorrelativo) {
      setFecha(fechaCorrelativo);
      setFechaPrevia(fechaCorrelativo);
      setFechaCorrelativo(null);
    } else if (partidaSeleccionada && partidaSeleccionada.Fraccion) {
      handleBusqueda();
    }
  }, [partidaSeleccionada, idioma, fechaCorrelativo]);

  useEffect(() => {
    if (
      partidaSeleccionada &&
      partidaSeleccionada.Fraccion &&
      fecha &&
      tarifa
    ) {
      setPartidaSeleccionada(null);
      reiniciaBusqueda();
    }
  }, [fecha, tarifa]);

  useEffect(() => {
    if (landing && landing.correlativo && landing.correlativo.length > 0)
      setPartidaSeleccionada(landing.correlativo[0]);

    if (reg.test(searchParams.get("hs"))) handleScrollClick(servicios);
  }, [landing.correlativo]);

  useEffect(() => {
    if (!Cookies.get("session_token")) {
      const uniqueId = uuidv4();
      Cookies.set("session_token", uniqueId);
      setSession(uniqueId);
    } else {
      setSession(Cookies.get("session_token"));
    }

    if (
      searchParams.get("hs") &&
      (searchParams.get("hs").length === 8 ||
        searchParams.get("hs").length === 10) &&
      searchParams.get("date") &&
      validarFecha(searchParams.get("date")) &&
      reg.test(searchParams.get("hs"))
    ) {
      let nueva = new Date(searchParams.get("date"));
      var newDate = new Date(nueva.getTime() + 10 * 60 * 60 * 1000);

      setFechaCorrelativo(newDate);

      getCorrelativo({
        texto: searchParams.get("hs"),
        tipo: "1",
        periodo: newDate.toLocaleDateString("en-US"),
        tipoConsulta: "1",
        idioma: idioma,
      });
    }
  }, []);

  const handleBusqueda = () => {
    if (tarifa === "2") {
      getDescripcion({
        texto: partidaSeleccionada.Fraccion,
        periodo: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
        session: session,
        dominio: window.location.hostname,
      });
      getHistorico({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getArancelPais({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });

      getPermisos({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getNoms({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getProhibiciones({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_mercancia_peligrosa({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_control_de_exportaciones({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_marcas_comerciales({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_10({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_12({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_14({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_21({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_21_dos({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_21_tres({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
    } else {
      getDescripcion({
        texto: partidaSeleccionada.Fraccion,
        periodo: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
        session: session,
        dominio: window.location.hostname,
      });
      getHistorico({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getTLCs({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        igi: partidaSeleccionada.IGI,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getALADIs({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        igi: partidaSeleccionada.IGI,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getFranja({
        fraccion: partidaSeleccionada.Fraccion,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getProhibiciones({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getArancelPais({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getPermisos({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getNoms({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getCuotasCompensatorias({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getImmex({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getPromocionSectorial({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getPreciosEstimados({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getArancelCupo({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getIva({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getIsan({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getIeps({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getPacic({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_mercancia_peligrosa({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_medidas_de_transicion({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_deposito_fiscal({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_mercancias_vulnerables({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_vehiculos_usados({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_marcas_comerciales({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_7({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_8({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_9({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_29({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_10({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_14({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_17({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_21({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_28({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_21_dos({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      get_anexo_21_tres({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getIsanDos({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getPreciosEstimadosDos({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
      getPreciosEstimadosTres({
        fraccion: partidaSeleccionada.Fraccion,
        tipo: tarifa,
        fecha: fecha
          ? fecha.toLocaleDateString("en-US")
          : new Date().toLocaleDateString("en-US"),
        idioma: idioma,
      });
    }
  };

  const handleCloseCuposALADI = () => {
    setOpenCuposALADI(false);
  };

  const handleClickOpenNotas = () => {
    setOpenNotas(true);
  };

  const handleCloseNotas = () => {
    setOpenNotas(false);
  };

  const handleCloseSTPS = () => {
    setOpenSTPS(false);
  };

  const handleClickOpenCupos = () => {
    setOpenCupos(true);
  };

  const handleCloseCupos = () => {
    setOpenCupos(false);
  };

  useEffect(() => {
    var dia = new Date().getDay();
    const dayInMillis = 24 * 60 * 60 * 1000;
    if (dia === 6 || dia === 0) {
      getIndicadores(
        findLastFriday(new Date())
          .toLocaleDateString("es-MX")
          .replace(new RegExp("/", "g"), "-")
      );
      getIndicadoresDos(
        findLastFriday(new Date())
          .toLocaleDateString("es-MX")
          .replace(new RegExp("/", "g"), "-")
      );
    } else if (dia === 1) {
      getIndicadores(
        findLastFriday(new Date())
          .toLocaleDateString("es-MX")
          .replace(new RegExp("/", "g"), "-")
      );
      getIndicadoresDos(
        new Date()
          .toLocaleDateString("es-MX")
          .replace(new RegExp("/", "g"), "-")
      );
    } else {
      const ayer = new Date(new Date().getTime() - dayInMillis);
      getIndicadores(
        ayer.toLocaleDateString("es-MX").replace(new RegExp("/", "g"), "-")
      );
      getIndicadoresDos(
        new Date()
          .toLocaleDateString("es-MX")
          .replace(new RegExp("/", "g"), "-")
      );
    }
  }, [getIndicadores, getIndicadoresDos]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangePageAladi = (event, newPage) => {
    setPageAladi(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangeRowsPerPageAladi = (event) => {
    setRowsPerPageAladi(+event.target.value);
    setPageAladi(0);
  };

  const handleChangeDate = (newValue) => {
    setFechaPrevia(newValue);
  };

  const handleChangeDateAceptar = () => {
    setFecha(fechaPrevia);
  };

  const handleChangeDateDos = (newValue) => {
    setFechaTabla(newValue);
  };

  const handleChangeSelect = (event) => {
    setTarifa(event.target.value);
  };

  const handleChange = (event, newValue) => {
    if (newValue === 1 && landing.capitulos.length === 0) {
      getCapitulos();
      getSecciones();
    }

    setValueConsulta(newValue);
  };

  const handleChangeIndex = (event, index) => {
    setValue(index);
  };

  return (
    <div className={classes.boxContainer} ref={servicios}>
      <div className="container-fluid">
        <Dialog
          open={openNotas}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseNotas}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{messages.notas}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {landing && landing.notas_tlc && landing.notas_tlc.length > 0
                ? React.createElement("div", {
                    dangerouslySetInnerHTML: {
                      __html: landing.notas_tlc[0].Decreto,
                    },
                  })
                : ""}
              <br></br>
              {landing && landing.notas_tlc && landing.notas_tlc.length > 0
                ? `${messages.unicamente}: ${landing.notas_tlc[0].Unicamente}`
                : ""}
              <br></br>
              {landing && landing.notas_tlc && landing.notas_tlc.length > 0
                ? `${messages.arancel}: ${landing.notas_tlc[0].Arancel}`
                : ""}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNotas}>{messages.cerrar}</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openCupos}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseCupos}
          aria-describedby="alert-dialog-slide-cupos"
        >
          <DialogTitle>{messages.cupos_por_tlc}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-cupos">
              {landing && landing.cupos_tlc && landing.cupos_tlc.length > 0 ? (
                <React.Fragment>
                  {cupoHeader && cupoHeader.fraccion ? (
                    <p>
                      <strong>{messages.fraccion}:</strong>{" "}
                      {cupoHeader.fraccion}
                      <br></br>
                      <strong>{messages.pais}:</strong> {cupoHeader.pais}
                      <br></br>
                      <strong>{messages.tratado}:</strong> {cupoHeader.tlc}
                    </p>
                  ) : (
                    ""
                  )}
                  <Typography variant="p">
                    {React.createElement("div", {
                      dangerouslySetInnerHTML: {
                        __html: landing.cupos_tlc[0].Acuerdo,
                      },
                    })}
                  </Typography>

                  <br />
                  <br />

                  <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{ maxHeight: 400 }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">{messages.cupo}</TableCell>
                          <TableCell align="center">
                            {messages.mercancia}
                          </TableCell>
                          <TableCell align="center">
                            {messages.observaciones}
                          </TableCell>
                          <TableCell align="center">
                            {messages.publicado}
                          </TableCell>
                          <TableCell align="center">
                            {messages.valido_desde}
                          </TableCell>
                          <TableCell align="center">
                            {messages.valido_hasta}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow hover={true}>
                          <TableCell align="center">
                            {landing.cupos_tlc[0].Cupo}
                          </TableCell>
                          <TableCell align="center">
                            {landing.cupos_tlc[0].Descripcion}
                          </TableCell>
                          <TableCell align="center">
                            {landing.cupos_tlc[0].Unicamente}
                          </TableCell>
                          <TableCell align="center">
                            {getFormatoFecha(
                              landing.cupos_tlc[0].Publicado,
                              idioma
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {getFormatoFecha(
                              landing.cupos_tlc[0].Desde,
                              idioma
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {getFormatoFecha(
                              landing.cupos_tlc[0].Hasta,
                              idioma
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </React.Fragment>
              ) : (
                ""
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseCupos}>{messages.cerrar}</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openCuposALADI}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseCuposALADI}
          aria-describedby="alert-dialog-slide-cupos"
        >
          <DialogTitle>Cupos por TLC</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-cupos">
              {landing &&
              landing.cupos_aladis_uno &&
              landing.cupos_aladis_uno.length > 0 ? (
                <React.Fragment>
                  {cupoHeaderALADI && cupoHeaderALADI.fraccion ? (
                    <p>
                      <strong>{messages.fraccion}:</strong>{" "}
                      {cupoHeaderALADI.fraccion}
                      <br></br>
                      <strong>{messages.pais}:</strong> {cupoHeaderALADI.pais}
                      <br></br>
                      <strong>{messages.tratado}:</strong> {cupoHeaderALADI.tlc}
                    </p>
                  ) : (
                    ""
                  )}
                  <Typography variant="p">
                    {landing.cupos_aladis_uno[cupoAladiNota].Acuerdo}
                  </Typography>

                  <br />
                  <br />

                  <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{ maxHeight: 400 }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">{messages.cupo}</TableCell>
                          <TableCell align="center">
                            {messages.mercancia}
                          </TableCell>
                          <TableCell align="center">
                            {messages.observaciones}
                          </TableCell>
                          <TableCell align="center">
                            {messages.publicado}
                          </TableCell>
                          <TableCell align="center">
                            {messages.valido_desde}
                          </TableCell>
                          <TableCell align="center">
                            {messages.valido_hasta}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {landing.cupos_aladis_uno.map((cupo, i) => (
                          <TableRow
                            hover={true}
                            key={i}
                            onClick={(a) => {
                              setCupoAladiNota(i);
                            }}
                            selected={i === cupoAladiNota}
                            sx={{ cursor: "pointer" }}
                          >
                            <TableCell align="center">
                              {cupo.Cupo}
                              <br />
                              <br />
                              {landing.cupos_aladis_dos &&
                              landing.cupos_aladis_dos.filter((frac) => {
                                return (
                                  frac.Clave === cupo.Clave &&
                                  frac.Grupo === cupo.Grupo
                                );
                              }).length > 1
                                ? "Códigos arancelarios:"
                                : ""}
                              <br />
                              {landing.cupos_aladis_dos &&
                              landing.cupos_aladis_dos.filter((frac) => {
                                return (
                                  frac.Clave === cupo.Clave &&
                                  frac.Grupo === cupo.Grupo
                                );
                              }).length > 1
                                ? landing.cupos_aladis_dos
                                    .filter((frac) => {
                                      return (
                                        frac.Clave === cupo.Clave &&
                                        frac.Grupo === cupo.Grupo
                                      );
                                    })
                                    .map((dos, i) => (
                                      <Typography variant="p" key={i}>
                                        {dos.Fraccion} - {dos.Unicamente} <br />
                                      </Typography>
                                    ))
                                : ""}
                            </TableCell>
                            <TableCell align="center">
                              {cupo.Descripcion}
                            </TableCell>
                            <TableCell align="center">
                              {cupo.Unicamente}
                            </TableCell>
                            <TableCell align="center">
                              {getFormatoFecha(cupo.Publicado, idioma)}
                            </TableCell>
                            <TableCell align="center">
                              {getFormatoFecha(cupo.Desde, idioma)}
                            </TableCell>
                            <TableCell align="center">
                              {getFormatoFecha(cupo.Hasta, idioma)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </React.Fragment>
              ) : (
                ""
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseCuposALADI}>{messages.cerrar}</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openSTPS}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseSTPS}
          aria-describedby="alert-dialog-slide-description-STPS"
        >
          <DialogTitle>{messages.regulacion_stps}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description-STPS">
              Para su IMPORTACIÓN al territorio nacional, las mercancías de
              cualquiera de las fracciones arancelarias de la Tarifa no deben
              haber sido producidas en su totalidad o en parte mediante uso de
              mano de obra de trabajadores en situación de trabajo forzoso u
              obligatorio, incluido el trabajo infantil forzoso u obligatorio.
              <br></br>
              <br></br>
              Fundamento legal: Artículo 23.6 del T-MEC; Artículo 4o., fracción
              III, 5o., fracciones III, X y XII, 6o., 15, 16, 17 y 20 de la Ley
              de Comercio Exterior; 5, fracción XVII del Reglamento Interior de
              la Secretaría de Economía; 4, fracción III, 5, fracción XIX, y 14,
              fracciones V y VII del Reglamento Interior de la Secretaría del
              Trabajo y Previsión Social.
              <br></br>
              <br></br>
              <Button variant="outlined">
                <Link
                  href="https://www.dof.gob.mx/nota_detalle.php?codigo=5679955&fecha=17/02/2023#gsc.tab=0"
                  target="_blank"
                  rel="noopener"
                  color="inherit"
                  underline="none"
                >
                  {messages.ver_decreto}
                </Link>
              </Button>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseSTPS}>{messages.cerrar}</Button>
          </DialogActions>
        </Dialog>

        <Typography align="center" className={classes.titulo}>
          {messages.titulo_tarifa}
        </Typography>

        <Grid container direction="row" style={{ marginTop: "50px" }}>
          <Grid item xs={12} md={11} className={classes.cardServicios}>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{ borderBottom: 1, borderColor: "divider", padding: "0px" }}
              >
                <Tabs
                  value={valueConsulta}
                  onChange={handleChange}
                  aria-label="Consulta la TIGIE"
                >
                  <Tab label={messages.busqueda} {...a11yProps(0)} />
                  <Tab label={messages.explorar} {...a11yProps(1)} />
                </Tabs>
              </Box>
              <TabPanel value={valueConsulta} index={0}>
                <Grid
                  container
                  direction="row"
                  sx={{ maxWidth: "50%", margin: "auto" }}
                >
                  <Grid item xs={12} md={6} sx={{ marginTop: "20px" }}>
                    <FormControl sx={{ width: "95%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Tarifa
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={tarifa}
                        label={messages.tarifa}
                        onChange={handleChangeSelect}
                      >
                        <MenuItem value="1">{messages.importacion}</MenuItem>
                        <MenuItem value="2">{messages.exportacion}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ marginTop: "20px" }}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      utils={DateFnsUtils}
                      locale={idioma === "es-MX" ? esLocale : enLocale}
                      sx={{
                        float: "left",
                        width: "100%",
                        textAlign: "center !important",
                      }}
                    >
                      <MobileDatePicker
                        label={messages.periodo}
                        value={fechaPrevia}
                        onChange={handleChangeDate}
                        onAccept={handleChangeDateAceptar}
                        inputFormat={"dd/MMM/yyyy"}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ textAlign: "center !important" }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>

                <Grid container direction="row" sx={{ marginTop: "20px" }}>
                  <Grid item xs={12} className={classes.cardServicios}>
                    <Autocomplete
                      disablePortal
                      id="busqueda-autocomplete"
                      isOptionEqualToValue={(option, value) => true}
                      filterOptions={(x) => x}
                      options={landing && landing.busqueda}
                      getOptionDisabled={(option) => option.Fraccion.length < 8}
                      getOptionLabel={(jsonResults) =>
                        partidaSeleccionada &&
                        Object.keys(partidaSeleccionada).length > 0
                          ? `${partidaSeleccionada.Fraccion} ${partidaSeleccionada.Descripcion}`
                          : ""
                      }
                      sx={{
                        width: "100%",
                        display: "inline-flex",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={messages.input_busqueda}
                        />
                      )}
                      renderOption={(props, jsonResults) => (
                        <Box
                          component="li"
                          {...props}
                          key={jsonResults.id}
                          sx={{ textAlign: "left" }}
                        >
                          {jsonResults.Fraccion}{" "}
                          {jsonResults.Descripcion.substring(0, 70)}
                        </Box>
                      )}
                      noOptionsText={messages.cero_resultados}
                      onChange={(event, value) => {
                        event.preventDefault();
                        setPartidaSeleccionada(value);
                      }}
                      onKeyUp={(event) => {
                        if (!regBusqueda.test(event.target.value)) {
                          // Prevent's default 'Enter' behavior.

                          event.defaultMuiPrevented = true;
                          // your handler code
                        } else if (
                          reg.test(event.target.value.replace(/\./g, ""))
                        ) {
                          if (event.target.value.replace(/\./g, "").length < 12)
                            getBusqueda({
                              texto: event.target.value.replace(/\./g, ""),
                              tipo: tarifa,
                              periodo: fecha
                                ? fecha.toLocaleDateString("en-US")
                                : new Date().toLocaleDateString("en-US"),
                              tipoConsulta: "1",
                              idioma: idioma,
                            });
                        } else if (event.target.value.length > 2) {
                          getBusqueda({
                            texto: event.target.value,
                            tipo: tarifa,
                            periodo: fecha
                              ? fecha.toLocaleDateString("en-US")
                              : new Date().toLocaleDateString("en-US"),
                            tipoConsulta: "2",
                            idioma: idioma,
                          });
                        } else {
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                {partidaSeleccionada &&
                Object.keys(partidaSeleccionada).length > 0 ? (
                  <Grid
                    container
                    direction="row"
                    sx={{
                      marginTop: "50px",
                      maxWidth: "100%",
                      overflow: "auto",
                    }}
                  >
                    <Grid item xs={12} className={classes.cardServicios}>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "bold",
                          marginBottom: "10px",
                        }}
                      >
                        {`${partidaSeleccionada.Fraccion.charAt(
                          0
                        )}${partidaSeleccionada.Fraccion.charAt(
                          1
                        )}${partidaSeleccionada.Fraccion.charAt(
                          2
                        )}${partidaSeleccionada.Fraccion.charAt(
                          3
                        )}.${partidaSeleccionada.Fraccion.charAt(
                          4
                        )}${partidaSeleccionada.Fraccion.charAt(
                          5
                        )}.${partidaSeleccionada.Fraccion.charAt(
                          6
                        )}${partidaSeleccionada.Fraccion.charAt(7)}${
                          partidaSeleccionada.Fraccion.charAt(8) ? "." : ""
                        }${
                          partidaSeleccionada.Fraccion.charAt(8)
                            ? partidaSeleccionada.Fraccion.charAt(8)
                            : ""
                        }${
                          partidaSeleccionada.Fraccion.charAt(9)
                            ? partidaSeleccionada.Fraccion.charAt(9)
                            : ""
                        }`}
                      </Typography>
                      <Typography
                        variant="h5"
                        sx={{
                          marginBottom: "10px",
                        }}
                      >
                        {partidaSeleccionada.Descripcion}
                      </Typography>

                      <Stack
                        direction={isShort ? "column" : "row"}
                        spacing={1}
                        sx={{
                          padding: "15px 0",
                          marginLeft: "auto",
                          marginRight: "auto",
                          width: "fit-content",
                        }}
                      >
                        <Button
                          variant="contained"
                          size="large"
                          disableElevation
                          sx={{ cursor: "default" }}
                        >
                          <strong>{tarifa === "1" ? "IGI:" : "IGE:"}</strong>{" "}
                          {tarifa === "1"
                            ? partidaSeleccionada.IGI
                            : partidaSeleccionada.IGE}
                        </Button>
                        <Button
                          variant="contained"
                          size="large"
                          disableElevation
                          sx={{ cursor: "default" }}
                        >
                          <strong>{messages.unidad_de_medida}:</strong>{" "}
                          {partidaSeleccionada.Descripcion_es}
                        </Button>
                        <Button
                          variant="contained"
                          size="large"
                          disableElevation
                          sx={{ cursor: "default" }}
                        >
                          <strong>{messages.unidad_m3}:</strong>{" "}
                          {partidaSeleccionada.M3}
                        </Button>
                        <Button
                          variant="contained"
                          size="large"
                          disableElevation
                          sx={{ cursor: "default" }}
                        >
                          <strong>{messages.fecha_publicacion}:</strong>{" "}
                          {getFormatoFecha(
                            partidaSeleccionada.Fecha_publicacion,
                            idioma
                          )}
                        </Button>
                        <Button
                          variant="contained"
                          size="large"
                          disableElevation
                          sx={{ cursor: "default" }}
                        >
                          <strong>{messages.vigencia}:</strong>{" "}
                          {getFormatoFecha(
                            partidaSeleccionada.Vigencia,
                            idioma
                          )}
                        </Button>
                      </Stack>

                      {tarifa === "1" && fecha >= new Date("2023-02-17") ? (
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{
                            padding: "5px 0",
                            marginLeft: "auto",
                            marginRight: "auto",
                            width: "fit-content",
                          }}
                        >
                          <Button
                            variant="contained"
                            size="large"
                            disableElevation
                            onClick={() => setOpenSTPS(true)}
                          >
                            {messages.regulacion_stps}
                          </Button>
                        </Stack>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}

                {partidaSeleccionada &&
                Object.keys(partidaSeleccionada).length > 0 ? (
                  <Grid container direction="row" style={{ marginTop: "25px" }}>
                    <Grid item xs={12} className={classes.cardServicios}>
                      {landing && Object.keys(landing).length > 0 ? (
                        <Tabs
                          value={value}
                          onChange={handleChangeIndex}
                          variant="scrollable"
                          scrollButtons
                          allowScrollButtonsMobile
                          aria-label="busqueda por fracción"
                          sx={{
                            boxShadow: "0px 0px 20px 2px rgba(0, 0, 0, 0.2)",
                          }}
                        >
                          <Tab
                            label={messages.descripcion}
                            {...a11yProps(0)}
                            disabled={
                              landing &&
                              landing.descripcion &&
                              landing.descripcion.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.arancel_por_pais}
                            {...a11yProps(1)}
                            disabled={
                              landing &&
                              landing.arancel &&
                              landing.arancel.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.historico}
                            {...a11yProps(2)}
                            disabled={
                              landing &&
                              landing.historico &&
                              landing.historico.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.tlcs}
                            {...a11yProps(3)}
                            disabled={
                              landing && landing.tlcs && landing.tlcs.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.aladi}
                            {...a11yProps(4)}
                            disabled={
                              landing &&
                              landing.aladis &&
                              landing.aladis.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.permisos}
                            {...a11yProps(5)}
                            disabled={
                              landing &&
                              landing.permisos &&
                              landing.permisos.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.noms}
                            {...a11yProps(6)}
                            disabled={
                              landing && landing.noms && landing.noms.length > 0
                                ? false
                                : true
                            }
                          />

                          <Tab
                            label={messages.cuotas_compensatorias}
                            {...a11yProps(7)}
                            disabled={
                              landing &&
                              landing.cuotasCompensatorias &&
                              landing.cuotasCompensatorias.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.immex}
                            {...a11yProps(8)}
                            disabled={
                              landing &&
                              landing.immex &&
                              landing.immex.length > 0
                                ? false
                                : true
                            }
                          />

                          <Tab
                            label={messages.promocion_sectorial}
                            {...a11yProps(9)}
                            disabled={
                              landing &&
                              landing.promocionSectorial &&
                              landing.promocionSectorial.length > 0
                                ? false
                                : true
                            }
                          />

                          <Tab
                            label={messages.precios_estimados}
                            {...a11yProps(10)}
                            disabled={
                              landing &&
                              landing.preciosEstimados &&
                              landing.precios_estimados_dos &&
                              (landing.preciosEstimados.length > 0 ||
                                landing.precios_estimados_dos.length > 0)
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.arancel_cupo}
                            {...a11yProps(11)}
                            disabled={
                              landing &&
                              landing.arancelCupo &&
                              landing.arancelCupo.length > 0
                                ? false
                                : true
                            }
                          />

                          <Tab
                            label={messages.franja_y_region}
                            {...a11yProps(12)}
                            disabled={
                              landing &&
                              landing.franja &&
                              landing.franja.length > 0
                                ? false
                                : true
                            }
                          />

                          <Tab
                            label={messages.iva}
                            {...a11yProps(13)}
                            disabled={
                              landing && landing.iva && landing.iva.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.isan}
                            {...a11yProps(14)}
                            disabled={
                              landing && landing.isan && landing.isan.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.ieps}
                            {...a11yProps(15)}
                            disabled={
                              landing && landing.ieps && landing.ieps.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.prohibiciones}
                            {...a11yProps(16)}
                            disabled={
                              landing &&
                              landing.prohibiciones &&
                              landing.prohibiciones.length > 0
                                ? false
                                : true
                            }
                          />

                          <Tab
                            label={messages.mercancia_peligrosa}
                            {...a11yProps(17)}
                            disabled={
                              landing &&
                              landing.mercancia_peligrosa &&
                              landing.mercancia_peligrosa.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.control_de_exportaciones}
                            {...a11yProps(18)}
                            disabled={
                              landing &&
                              landing.control_de_exportaciones &&
                              landing.control_de_exportaciones.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.medidas_de_transicion}
                            {...a11yProps(19)}
                            disabled={
                              landing &&
                              landing.medidas_de_transicion &&
                              landing.medidas_de_transicion.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.deposito_fiscal}
                            {...a11yProps(20)}
                            disabled={
                              landing &&
                              landing.deposito_fiscal &&
                              landing.deposito_fiscal.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.mercancias_vulnerables}
                            {...a11yProps(21)}
                            disabled={
                              landing &&
                              landing.mercancias_vulnerables &&
                              landing.mercancias_vulnerables.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.vehiculos_usados}
                            {...a11yProps(22)}
                            disabled={
                              landing &&
                              landing.vehiculos_usados &&
                              landing.vehiculos_usados.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.padron_pacic}
                            {...a11yProps(23)}
                            disabled={
                              landing &&
                              landing.pacic &&
                              landing.pacic.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.marcas_comerciales}
                            {...a11yProps(24)}
                            disabled={
                              landing &&
                              landing.marcas_comerciales &&
                              landing.marcas_comerciales.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_7}
                            {...a11yProps(25)}
                            disabled={
                              landing &&
                              landing.anexo_7 &&
                              landing.anexo_7.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_8}
                            {...a11yProps(26)}
                            disabled={
                              landing &&
                              landing.anexo_8 &&
                              landing.anexo_8.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_9}
                            {...a11yProps(27)}
                            disabled={
                              landing &&
                              landing.anexo_9 &&
                              landing.anexo_9.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_29}
                            {...a11yProps(28)}
                            disabled={
                              landing &&
                              landing.anexo_29 &&
                              landing.anexo_29.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_10}
                            {...a11yProps(29)}
                            disabled={
                              landing &&
                              landing.anexo_10 &&
                              landing.anexo_10.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_12}
                            {...a11yProps(30)}
                            disabled={
                              landing &&
                              landing.anexo_12 &&
                              landing.anexo_12.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_14}
                            {...a11yProps(31)}
                            disabled={
                              landing &&
                              landing.anexo_14 &&
                              landing.anexo_14.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_17}
                            {...a11yProps(32)}
                            disabled={
                              landing &&
                              landing.anexo_17 &&
                              landing.anexo_17.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_21}
                            {...a11yProps(33)}
                            disabled={
                              landing &&
                              landing.anexo_21 &&
                              landing.anexo_21.length > 0
                                ? false
                                : true
                            }
                          />
                          <Tab
                            label={messages.anexo_28}
                            {...a11yProps(34)}
                            disabled={
                              landing &&
                              landing.anexo_28 &&
                              landing.anexo_28.length > 0
                                ? false
                                : true
                            }
                          />
                        </Tabs>
                      ) : (
                        ""
                      )}
                      <SwipeableViews
                        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                      >
                        <TabPanel value={value} index={0} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.descripcion &&
                              landing.descripcion.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table
                                    stickyHeader
                                    aria-label="collapsible table"
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>{messages.notas}</TableCell>
                                        <TableCell>{messages.tipo}</TableCell>
                                        <TableCell>{messages.codigo}</TableCell>
                                        <TableCell align="left">
                                          {messages.descripcion}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.descripcion.map((row, i) => (
                                        <RowDescripcion
                                          key={i}
                                          row={row}
                                          notas={landing.notas}
                                          getNotas={getNotas}
                                          periodo={fecha ? fecha : new Date()}
                                        />
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                <Stack spacing={1} sx={{ width: "100%" }}>
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                </Stack>
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={1} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.arancel &&
                              landing.arancel.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.pais}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.arancel}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unicamente}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.arancel.map((row, i) => (
                                        <RowArancel
                                          key={i}
                                          row={row}
                                          i={i}
                                          idioma={idioma}
                                        ></RowArancel>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel value={value} index={2} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.historico &&
                              landing.historico.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table
                                    stickyHeader
                                    aria-label="collapsible table"
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.fraccion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.arancel}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unidad_de_medida}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unidad_m3}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.historico.map((row, i) => (
                                        <TableRow key={i} hover={true}>
                                          <TableCell align="center">
                                            {row.Orden === 1 ? (
                                              row.Fraccion
                                            ) : (
                                              <Button
                                                variant="outlined"
                                                onClick={() => {
                                                  let nueva = new Date(
                                                    row.Vigencia
                                                  );
                                                  var newDate = new Date(
                                                    nueva.getTime() +
                                                      10 * 60 * 60 * 1000
                                                  );

                                                  setFechaCorrelativo(newDate);

                                                  getCorrelativo({
                                                    texto: row.Fraccion,
                                                    tipo: tarifa,
                                                    periodo: newDate.toLocaleDateString(
                                                      "en-US"
                                                    ),
                                                    tipoConsulta: "1",
                                                    idioma: idioma,
                                                  });
                                                }}
                                              >
                                                {row.Fraccion}
                                              </Button>
                                            )}
                                          </TableCell>
                                          <TableCell align="center">
                                            {row.Descripcion}
                                          </TableCell>
                                          <TableCell align="center">
                                            <Typography
                                              noWrap={true}
                                              variant="subtitle2"
                                            >
                                              {getFormatoFecha(
                                                row.Vigencia,
                                                idioma
                                              )}
                                            </Typography>
                                          </TableCell>
                                          <TableCell align="center">
                                            <Typography
                                              noWrap={true}
                                              variant="subtitle2"
                                            >
                                              {getFormatoFecha(
                                                row.Fecha_publicacion,
                                                idioma
                                              )}
                                            </Typography>
                                          </TableCell>
                                          <TableCell align="center">
                                            {row.IGI}
                                          </TableCell>
                                          <TableCell align="center">
                                            {row.Unidad_medida}
                                          </TableCell>
                                          <TableCell align="center">
                                            {row.M3}
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                <Stack spacing={1} sx={{ width: "100%" }}>
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                </Stack>
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={3} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid
                              item
                              xs={12}
                              md={6}
                              className={classes.cardServicios}
                            >
                              <TextField
                                id="filled-basic"
                                label="Busqueda por país"
                                variant="outlined"
                                sx={{ width: "100%", marginBottom: "34px" }}
                                value={paisSeleccionado}
                                onChange={(e) => {
                                  setPaisSeleccionado(e.target.value);
                                  setPage(0);
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.tlcs &&
                              landing.tlcs.length > 0 ? (
                                <React.Fragment>
                                  <TableContainer
                                    component={Paper}
                                    sx={{ maxHeight: isShort ? 400 : 800 }}
                                  >
                                    <Table
                                      stickyHeader
                                      aria-label="sticky table"
                                    >
                                      <TableHead>
                                        <TableRow>
                                          <TableCell align="center">
                                            {messages.notas}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.pais}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.arancel}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.unicamente}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.notas}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.publicado}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.valido_desde}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.valido_hasta}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.cupo}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {landing.tlcs
                                          .filter((tlc) => {
                                            return paisSeleccionado
                                              ? tlc.Nombre.toUpperCase().includes(
                                                  paisSeleccionado.toUpperCase()
                                                )
                                              : true;
                                          })
                                          .slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                          )
                                          .map((row, i) => (
                                            <RowTLCs
                                              key={i}
                                              row={row}
                                              fraccion={
                                                partidaSeleccionada.Fraccion
                                              }
                                              setCupoHeader={setCupoHeader}
                                              fecha={
                                                fecha
                                                  ? fecha.toLocaleDateString(
                                                      "en-US"
                                                    )
                                                  : new Date().toLocaleDateString(
                                                      "en-US"
                                                    )
                                              }
                                              setTlcSeleccionado={
                                                setTlcSeleccionado
                                              }
                                              tlcSeleccionado={tlcSeleccionado}
                                              handleOpenNotas={
                                                handleClickOpenNotas
                                              }
                                              handleOpenCupos={
                                                handleClickOpenCupos
                                              }
                                              getCuposTLC={getCuposTLC}
                                              getNotasTLC={getNotasTLC}
                                              i={i}
                                              idioma={idioma}
                                            ></RowTLCs>
                                          ))}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                  <TablePagination
                                    rowsPerPageOptions={[10, 25, 100, 200]}
                                    component="div"
                                    count={
                                      landing.tlcs.filter((tlc) => {
                                        return paisSeleccionado
                                          ? tlc.Nombre.toUpperCase().includes(
                                              paisSeleccionado.toUpperCase()
                                            )
                                          : true;
                                      }).length
                                    }
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={
                                      handleChangeRowsPerPage
                                    }
                                  />
                                </React.Fragment>
                              ) : (
                                <Stack spacing={1} sx={{ width: "100%" }}>
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                </Stack>
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={4} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid
                              item
                              xs={12}
                              md={6}
                              className={classes.cardServicios}
                            >
                              <TextField
                                id="filled-basic"
                                label="Busqueda por país"
                                variant="outlined"
                                sx={{ width: "100%", marginBottom: "34px" }}
                                value={paisSeleccionadoAladi}
                                onChange={(e) => {
                                  setPaisSeleccionadoAladi(e.target.value);
                                  setPageAladi(0);
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.aladis &&
                              landing.aladis.length > 0 ? (
                                <React.Fragment>
                                  <TableContainer
                                    component={Paper}
                                    sx={{ maxHeight: isShort ? 400 : 800 }}
                                  >
                                    <Table
                                      stickyHeader
                                      aria-label="sticky table"
                                    >
                                      <TableHead>
                                        <TableRow>
                                          <TableCell align="center">
                                            {messages.notas}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.pais}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.arancel}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.unicamente}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.publicado}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.valido_desde}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.valido_hasta}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.code}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.cupo}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {landing.aladis
                                          .filter((tlc) => {
                                            return paisSeleccionadoAladi
                                              ? tlc.Nombre.toUpperCase().includes(
                                                  paisSeleccionadoAladi.toUpperCase()
                                                )
                                              : true;
                                          })
                                          .slice(
                                            pageAladi * rowsPerPageAladi,
                                            pageAladi * rowsPerPageAladi +
                                              rowsPerPageAladi
                                          )
                                          .map((row, i) => (
                                            <RowAladi
                                              key={i}
                                              row={row}
                                              setAladiSeleccionado={
                                                setAladiSeleccionado
                                              }
                                              aladiSeleccionado={
                                                aladiSeleccionado
                                              }
                                              i={i}
                                              handleOpenCuposALADI={
                                                handleOpenCuposALADI
                                              }
                                              getCuposALADIUno={
                                                getCuposALADIUno
                                              }
                                              getCuposALADIDos={
                                                getCuposALADIDos
                                              }
                                              setCupoHeaderALADI={
                                                setCupoHeaderALADI
                                              }
                                              fraccion={
                                                partidaSeleccionada.Fraccion
                                              }
                                              fecha={
                                                fecha
                                                  ? fecha.toLocaleDateString(
                                                      "en-US"
                                                    )
                                                  : new Date().toLocaleDateString(
                                                      "en-US"
                                                    )
                                              }
                                              idioma={idioma}
                                            ></RowAladi>
                                          ))}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                  <TablePagination
                                    rowsPerPageOptions={[10, 25, 100, 200]}
                                    component="div"
                                    count={
                                      landing.aladis.filter((aladi) => {
                                        return paisSeleccionadoAladi
                                          ? aladi.Nombre.toUpperCase().includes(
                                              paisSeleccionadoAladi.toUpperCase()
                                            )
                                          : true;
                                      }).length
                                    }
                                    rowsPerPage={rowsPerPageAladi}
                                    page={pageAladi}
                                    onPageChange={handleChangePageAladi}
                                    onRowsPerPageChange={
                                      handleChangeRowsPerPageAladi
                                    }
                                  />
                                </React.Fragment>
                              ) : (
                                <Stack spacing={1} sx={{ width: "100%" }}>
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    sx={{ height: "65px" }}
                                  />
                                </Stack>
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={5} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.permisos &&
                              landing.permisos.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unicamente}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.secretaria}
                                        </TableCell>
                                        <TableCell align="center">M3</TableCell>
                                        <TableCell align="center">
                                          {messages.permisos}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.permisos.map((row, i) => (
                                        <RowPermisos
                                          key={i}
                                          row={row}
                                          i={i}
                                          idioma={idioma}
                                        ></RowPermisos>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={6} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.noms &&
                              landing.noms.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          NOM
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unicamente}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.noms.map((row, i) => (
                                        <RowNoms
                                          key={i}
                                          row={row}
                                          i={i}
                                          idioma={idioma}
                                        ></RowNoms>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={7} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.cuotasCompensatorias &&
                              landing.cuotasCompensatorias.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.cuota}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.pais}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.producto}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.empresa}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.cuotasCompensatorias.map(
                                        (row, i) => (
                                          <RowCuotasCompensatorias
                                            key={i}
                                            row={row}
                                            i={i}
                                            idioma={idioma}
                                          ></RowCuotasCompensatorias>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={8} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.immex &&
                              landing.immex.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.anexo}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.immex.map((row, i) => (
                                        <RowImmex
                                          key={i}
                                          row={row}
                                          i={i}
                                          idioma={idioma}
                                        ></RowImmex>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={9} dir={theme.direction}>
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.promocionSectorial &&
                              landing.promocionSectorial.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.sector}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.inciso}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.arancel}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unicamente}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.promocionSectorial.map(
                                        (row, i) => (
                                          <RowPromocionSectorial
                                            key={i}
                                            row={row}
                                            i={i}
                                            idioma={idioma}
                                          ></RowPromocionSectorial>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={10}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.preciosEstimados &&
                              landing.preciosEstimados.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          Unidad
                                        </TableCell>
                                        <TableCell align="center">
                                          Precio estimado (USD por unidad)
                                        </TableCell>

                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.preciosEstimados.map(
                                        (row, i) => (
                                          <RowPreciosEstimados
                                            key={i}
                                            row={row}
                                            i={i}
                                            idioma={idioma}
                                            messages={messages}
                                          ></RowPreciosEstimados>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : landing &&
                                landing.precios_estimados_dos &&
                                landing.precios_estimados_tres &&
                                landing.precios_estimados_dos.length > 0 ? (
                                <React.Fragment>
                                  <Card
                                    sx={{
                                      maxHeight: 400,
                                      textAlign: "justify",
                                      padding: "30px 50px",
                                      overflow: "auto",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    <CardContent>
                                      <Typography variant="h5">
                                        Decreto:
                                      </Typography>
                                      <br />
                                      <Typography variant="h5">
                                        {React.createElement("div", {
                                          dangerouslySetInnerHTML: {
                                            __html:
                                              landing.precios_estimados_dos[0]
                                                .Decreto,
                                          },
                                        })}
                                      </Typography>
                                      <br />

                                      <Typography
                                        variant="h5"
                                        sx={{ paddingTop: "10px" }}
                                      >
                                        {`${
                                          messages.publicado
                                        }: ${getFormatoFecha(
                                          landing.precios_estimados_dos[0]
                                            .Publicado,
                                          idioma
                                        )}`}
                                        <br />
                                        {`${
                                          messages.valido_desde
                                        }: ${getFormatoFecha(
                                          landing.precios_estimados_dos[0]
                                            .Desde,
                                          idioma
                                        )}`}
                                        <br />
                                        {`${
                                          messages.validado_hasta
                                        }: ${getFormatoFecha(
                                          landing.precios_estimados_dos[0]
                                            .Hasta,
                                          idioma
                                        )}`}

                                        <br />
                                      </Typography>
                                      <br />
                                      <Typography variant="h5">
                                        {`Anexo 2: ${landing.precios_estimados_dos[0].Titulo}`}
                                      </Typography>
                                    </CardContent>
                                  </Card>

                                  <TableContainer
                                    component={Paper}
                                    sx={{ maxHeight: 500 }}
                                  >
                                    <Table
                                      stickyHeader
                                      aria-label="sticky table"
                                    >
                                      <TableHead>
                                        <TableRow>
                                          <TableCell align="center">
                                            Titulo
                                          </TableCell>
                                          <TableCell align="center">
                                            10 Años o más
                                          </TableCell>
                                          <TableCell align="center">
                                            9 Años
                                          </TableCell>
                                          <TableCell align="center">
                                            8 Años
                                          </TableCell>
                                          <TableCell align="center">
                                            7 Años
                                          </TableCell>
                                          <TableCell align="center">
                                            6 Años
                                          </TableCell>
                                          <TableCell align="center">
                                            5 Años
                                          </TableCell>
                                          <TableCell align="center">
                                            4 Años
                                          </TableCell>
                                          <TableCell align="center">
                                            3 Años
                                          </TableCell>
                                          <TableCell align="center">
                                            2 Años
                                          </TableCell>
                                          <TableCell align="center">
                                            1 Años
                                          </TableCell>

                                          <TableCell align="center">
                                            {messages.publicado}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.valido_desde}
                                          </TableCell>
                                          <TableCell align="center">
                                            {messages.valido_hasta}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {landing.precios_estimados_tres.map(
                                          (row, i) => (
                                            <TableRow hover={true} key={i}>
                                              <TableCell align="center">
                                                {row.Descripcion}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano10}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano9}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano8}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano7}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano6}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano5}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano4}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano3}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano2}
                                              </TableCell>
                                              <TableCell align="center">
                                                {row.Ano1}
                                              </TableCell>

                                              <TableCell align="center">
                                                <Typography
                                                  noWrap={true}
                                                  variant="subtitle2"
                                                >
                                                  {getFormatoFecha(
                                                    row.Publicado,
                                                    idioma
                                                  )}
                                                </Typography>
                                              </TableCell>
                                              <TableCell align="center">
                                                <Typography
                                                  noWrap={true}
                                                  variant="subtitle2"
                                                >
                                                  {getFormatoFecha(
                                                    row.Desde,
                                                    idioma
                                                  )}
                                                </Typography>
                                              </TableCell>
                                              <TableCell align="center">
                                                <Typography
                                                  noWrap={true}
                                                  variant="subtitle2"
                                                >
                                                  {getFormatoFecha(
                                                    row.Hasta,
                                                    idioma
                                                  )}
                                                </Typography>
                                              </TableCell>
                                            </TableRow>
                                          )
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </React.Fragment>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={11}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.arancelCupo &&
                              landing.arancelCupo.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          Orden
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unicamente}
                                        </TableCell>
                                        <TableCell align="center">
                                          Unidad
                                        </TableCell>
                                        <TableCell align="center">
                                          Unidad M3
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.arancel}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.arancelCupo.map((row, i) => (
                                        <RowArancelCupo
                                          key={i}
                                          row={row}
                                          i={i}
                                          j={landing.arancelCupo.length}
                                          idioma={idioma}
                                        ></RowArancelCupo>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={12}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.franja &&
                              landing.franja.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.arancel}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.franja.map((row, i) => (
                                        <RowFranja
                                          key={i}
                                          row={row}
                                          i={i}
                                          idioma={idioma}
                                        ></RowFranja>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={13}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing && landing.iva && landing.iva.length > 0
                                ? landing.iva.map((row, i) => (
                                    <Card
                                      key={i}
                                      sx={{
                                        maxHeight: 400,
                                        textAlign: "justify",
                                        padding: "30px 50px",
                                        overflow: "auto",
                                        marginBottom: "20px",
                                      }}
                                    >
                                      <CardContent>
                                        <Typography
                                          variant="h5"
                                          sx={{ padding: "15px 20px" }}
                                        >
                                          La fracción arancelaria está incluída
                                          en el Anexo 27 de la RGCE y exenta del
                                          pago de IVA de acuerdo lo siguiente:
                                        </Typography>

                                        <Typography
                                          variant="h6"
                                          sx={{ padding: "15px 20px" }}
                                        >
                                          {`Fundamento: ${row.Fundamento}`}
                                          <br></br>
                                          {`Nota: ${row.Notas}`}
                                          <br></br>
                                          {`Válido desde: ${getFormatoFecha(
                                            row.Desde,
                                            idioma
                                          )}`}
                                          <br></br>
                                          {`Válido hasta: ${getFormatoFecha(
                                            row.Hasta,
                                            idioma
                                          )}`}
                                          <br></br>
                                          {`${
                                            messages.publicado
                                          }: ${getFormatoFecha(
                                            row.Publicado,
                                            idioma
                                          )}`}
                                        </Typography>
                                      </CardContent>
                                    </Card>
                                  ))
                                : ""}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={14}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.isan &&
                              landing.isan.length > 0 ? (
                                <Paper
                                  component={Paper}
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                  }}
                                >
                                  <Typography variant="h5">
                                    {messages.isan_dos}
                                  </Typography>
                                  <Typography
                                    variant="p"
                                    sx={{ paddingTop: "15px" }}
                                  >
                                    {messages.isan_tres}
                                    <br />
                                    <br />
                                    {messages.isan_0}
                                    <br />
                                    <br />
                                    {`${messages.isan_1_1}${landing.isan[0].Exento}${messages.isan_1_2}`}
                                    <br />
                                    <br />
                                    {`${messages.isan_2_1}${landing.isan[0].Exento}${messages.isan_2_2}${landing.isan[0].Exento50}${messages.isan_2_3}`}
                                    <br />
                                    <br />
                                    {messages.isan_3}
                                    <br />
                                    <br />
                                    {messages.isan_4}
                                    <br />
                                    <br />

                                    {landing.isan_dos ? messages.isan_5 : ""}
                                    <br />
                                    <br />

                                    {landing.isan_dos ? (
                                      <TableContainer
                                        component={Paper}
                                        sx={{ maxHeight: 500 }}
                                      >
                                        <Table
                                          stickyHeader
                                          aria-label="sticky table"
                                        >
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align="center">
                                                {messages.limite_inferior}
                                              </TableCell>
                                              <TableCell align="center">
                                                {messages.limite_superior}
                                              </TableCell>
                                              <TableCell align="center">
                                                {messages.cuota_fija}
                                              </TableCell>
                                              <TableCell align="center">
                                                {messages.porcentaje_excedente}
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {landing.isan_dos.map((row, i) => (
                                              <TableRow hover={true} key={i}>
                                                <TableCell align="center">
                                                  {row.Inferior}
                                                </TableCell>
                                                <TableCell align="center">
                                                  {row.Superior === 0
                                                    ? messages.en_adelante
                                                    : row.Superior}
                                                </TableCell>
                                                <TableCell align="center">
                                                  {row.CuotaFija}
                                                </TableCell>
                                                <TableCell align="center">
                                                  {row.Excedente}
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    ) : (
                                      ""
                                    )}

                                    <br />
                                    <br />

                                    {`${messages.publicado}: ${getFormatoFecha(
                                      landing.isan[0].Publicado,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.valido_desde
                                    }: ${getFormatoFecha(
                                      landing.isan[0].Desde,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.valido_hasta
                                    }: ${getFormatoFecha(
                                      landing.isan[0].Hasta,
                                      idioma
                                    )}`}
                                  </Typography>
                                </Paper>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={15}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.ieps &&
                              landing.ieps.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                  }}
                                >
                                  <CardContent>
                                    <Typography variant="h5">
                                      La presente fracción arancelaria puede
                                      requerir el pago del Impuesto Especial
                                      sobre Producción y Servicios de acuerdo a
                                      lo siguiente:
                                    </Typography>
                                    {landing.ieps.map((articulo) => (
                                      <Typography
                                        variant="p"
                                        sx={{ paddingTop: "15px" }}
                                      >
                                        <br />
                                        <hr size="4px" color="black" />

                                        {React.createElement("div", {
                                          dangerouslySetInnerHTML: {
                                            __html: articulo.Decreto,
                                          },
                                        })}
                                        <br />

                                        {`${
                                          messages.publicado
                                        }: ${getFormatoFecha(
                                          articulo.Publicado,
                                          idioma
                                        )}`}
                                        <br />
                                        {`${
                                          messages.valido_desde
                                        }: ${getFormatoFecha(
                                          articulo.Vigencia,
                                          idioma
                                        )}`}
                                        <br />
                                        {`${
                                          messages.validado_hasta
                                        }: ${getFormatoFecha(
                                          articulo.VigenciaHasta,
                                          idioma
                                        )}`}
                                        <br />
                                        {`Decreto publicado el: ${getFormatoFecha(
                                          articulo.PubDec,
                                          idioma
                                        )}`}
                                      </Typography>
                                    ))}
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={16}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.prohibiciones &&
                              landing.prohibiciones.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.pais}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.fraccion_partida}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unicamente}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.prohibiciones.map((row, i) => (
                                        <RowProhibicion
                                          key={i}
                                          row={row}
                                          i={i}
                                          idioma={idioma}
                                        ></RowProhibicion>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={17}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.mercancia_peligrosa &&
                              landing.mercancia_peligrosa.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                  }}
                                >
                                  <CardContent>
                                    <Typography variant="h5">
                                      La presente fracción arancelaria está
                                      incluida en el Anexo 23 de las RGCE,
                                      marcada como Mercancías peligrosas o que
                                      requieran instalaciones y/o equipos
                                      especiales para su muestreo.{" "}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="p"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      <br />
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.mercancia_peligrosa[0]
                                          .Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.mercancia_peligrosa[0].Vigencia,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.mercancia_peligrosa[0]
                                          .VigenciaHasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={18}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.control_de_exportaciones &&
                              landing.control_de_exportaciones.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          Anexo
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unicamente}
                                        </TableCell>

                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.control_de_exportaciones.map(
                                        (row, i) => (
                                          <RowControlDeExportaciones
                                            key={i}
                                            row={row}
                                            i={i}
                                            idioma={idioma}
                                          ></RowControlDeExportaciones>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={19}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.medidas_de_transicion &&
                              landing.medidas_de_transicion.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.pais}
                                        </TableCell>
                                        <TableCell align="center">
                                          Pago %
                                        </TableCell>
                                        <TableCell align="center">
                                          Nota
                                        </TableCell>
                                        <TableCell align="center">
                                          Valor máximo
                                        </TableCell>
                                        <TableCell align="center">
                                          Nota
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.medidas_de_transicion.map(
                                        (row, i) => (
                                          <RowMedidasTransicion
                                            key={i}
                                            row={row}
                                            i={i}
                                            idioma={idioma}
                                          ></RowMedidasTransicion>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={20}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.deposito_fiscal &&
                              landing.deposito_fiscal.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <CardContent>
                                    <Typography variant="h5">
                                      {React.createElement("div", {
                                        dangerouslySetInnerHTML: {
                                          __html:
                                            landing.deposito_fiscal[0].Decreto,
                                        },
                                      })}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="p"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      <br />
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.deposito_fiscal[0].Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.deposito_fiscal[0].Desde,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.deposito_fiscal[0].Hasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={21}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.mercancias_vulnerables &&
                              landing.mercancias_vulnerables.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <CardContent>
                                    <Typography variant="h5">
                                      La presente fraccion arancelaria se
                                      encuentra listada en el anexo de la
                                      resolución por la que se expiden los
                                      formatos oficiales de los avisos e
                                      informes que deben presentar quienes
                                      realicen actividades vulnerables.
                                    </Typography>
                                    <br />
                                    <Typography variant="h5">
                                      {landing.mercancias_vulnerables[0].Regla}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="p"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      <br />
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.mercancias_vulnerables[0]
                                          .Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.mercancias_vulnerables[0].Desde,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.mercancias_vulnerables[0].Hasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={22}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.vehiculos_usados &&
                              landing.vehiculos_usados.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          {messages.notas}
                                        </TableCell>
                                        <TableCell align="center">
                                          Orden
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.unicamente}
                                        </TableCell>
                                        <TableCell align="center">
                                          Unidad
                                        </TableCell>
                                        <TableCell align="center">
                                          Unidad M3
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.arancel}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.vehiculos_usados.map(
                                        (row, i) => (
                                          <RowVehiculosUsados
                                            key={i}
                                            row={row}
                                            i={i}
                                            j={landing.vehiculos_usados.length}
                                            idioma={idioma}
                                          ></RowVehiculosUsados>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={23}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.pacic &&
                              landing.pacic.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                  }}
                                >
                                  <CardContent>
                                    <Typography variant="h5">
                                      La fracción arancelaria se encuentra
                                      listada en el DECRETO por el que se exenta
                                      el pago de arancel de importación y se
                                      otorgan facilidades administrativas a
                                      diversas mercancías de la canasta básica e
                                      insumos que se indican.{" "}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="p"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      {React.createElement("div", {
                                        dangerouslySetInnerHTML: {
                                          __html: landing.pacic[0].Decreto,
                                        },
                                      })}
                                      <br />
                                      <strong>
                                        {landing.pacic[0].Acotacion}
                                      </strong>
                                      <br />
                                      <br />
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.pacic[0].Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.pacic[0].Desde,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.pacic[0].Hasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={24}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.marcas_comerciales &&
                              landing.marcas_comerciales.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <CardContent>
                                    <Typography variant="h5">
                                      La fracción arancelaria se encuentra
                                      listada en el Anexo 20 de las RGCE:
                                      Fracciones arancelarias sujetas a la
                                      declaración de marcas comerciales
                                      registradas
                                    </Typography>
                                    <br />
                                    <Typography variant="h5">
                                      {React.createElement("div", {
                                        dangerouslySetInnerHTML: {
                                          __html:
                                            landing.marcas_comerciales[0].Regla,
                                        },
                                      })}
                                      <br />
                                      {landing.marcas_comerciales[0].Unicamente}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="p"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      <br />
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.marcas_comerciales[0].Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.marcas_comerciales[0].Desde,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.marcas_comerciales[0].Hasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={25}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_7 &&
                              landing.anexo_7.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <CardContent>
                                    <Typography
                                      sx={{ fontWeight: "bold" }}
                                      variant="h5"
                                    >
                                      La fracción arancelaria se encuentra
                                      listada en el Anexo 7 de las RGCE:
                                      Fracciones arancelarias que identifican
                                      los insumos y diversas mercancías
                                      relacionadas con el sector agropecuario a
                                      que se refiere la regla 1.3.1., fracción
                                      XI.
                                    </Typography>
                                    <br />
                                    <Typography variant="h5">
                                      {landing.anexo_7[0].Regla}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="p"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      <br />
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.anexo_7[0].Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.anexo_7[0].Desde,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.anexo_7[0].Hasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                        <TabPanel
                          value={value}
                          index={26}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_8 &&
                              landing.anexo_8.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <CardContent>
                                    <Typography
                                      variant="h5"
                                      sx={{ fontWeight: "bold" }}
                                    >
                                      La fracción arancelaria se encuentra
                                      listada en el Anexo 8 de las RGCE:
                                      Fracciones arancelarias que identifican
                                      los bienes de capital a que se refiere la
                                      regla 1.3.1., fracción XII.
                                    </Typography>
                                    <br />
                                    <Typography variant="h5">
                                      {landing.anexo_8[0].Regla}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="p"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      <br />
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.anexo_8[0].Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.anexo_8[0].Desde,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.anexo_8[0].Hasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={27}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_9 &&
                              landing.anexo_9.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <CardContent>
                                    <Typography
                                      variant="h5"
                                      sx={{ fontWeight: "bold" }}
                                    >
                                      La fracción arancelaria se encuentra
                                      listada en el Anexo 9 de las RGCE:
                                      Fracciones arancelarias que se autorizan a
                                      importar de conformidad con el artículo
                                      61, fracción XIV de la Ley Aduanera.
                                    </Typography>
                                    <br />
                                    <Typography variant="h5">
                                      {landing.anexo_9[0].Regla}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="p"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      <br />
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.anexo_9[0].Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.anexo_9[0].Desde,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.anexo_9[0].Hasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={28}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_29 &&
                              landing.anexo_29.length > 0 ? (
                                <Card
                                  sx={{
                                    maxHeight: 800,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    overflow: "auto",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <CardContent>
                                    <Typography
                                      variant="h5"
                                      sx={{ fontWeight: "bold" }}
                                    >
                                      La fracción arancelaria se encuentra
                                      listada en el Anexo 9 de las RGCE:
                                      Fracciones arancelarias que se autorizan a
                                      importar de conformidad con el artículo
                                      61, fracción XIV de la Ley Aduanera.
                                    </Typography>
                                    <br />
                                    <Typography variant="h5">
                                      {landing.anexo_29[0].Regla}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="p"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      <br />
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.anexo_29[0].Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.anexo_29[0].Desde,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.anexo_29[0].Hasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </CardContent>
                                </Card>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={29}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_10 &&
                              landing.anexo_10.length > 0 ? (
                                <TableContainer
                                  component={Paper}
                                  sx={{ maxHeight: isShort ? 400 : 800 }}
                                >
                                  <Typography
                                    variant="h5"
                                    sx={{
                                      paddingTop: "30px",
                                      paddingLeft: "20px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    La fracción arancelaria está incluida en el
                                    Anexo 10 de las RGCE: Sectores y fracciones
                                    arancelarias
                                  </Typography>
                                  <br />

                                  <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">
                                          Sector
                                        </TableCell>
                                        <TableCell align="center">
                                          Nota
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.publicado}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_desde}
                                        </TableCell>
                                        <TableCell align="center">
                                          {messages.valido_hasta}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {landing.anexo_10.map((row, i) => (
                                        <TableRow hover={true} key={i}>
                                          <TableCell align="center">
                                            {row.Sector}
                                            {".- "}
                                            {row.Titulo}
                                          </TableCell>
                                          <TableCell align="center">
                                            {row.NotasSector}
                                          </TableCell>
                                          <TableCell align="center">
                                            <Typography
                                              noWrap={true}
                                              variant="subtitle2"
                                            >
                                              {getFormatoFecha(
                                                row.Publicado,
                                                idioma
                                              )}
                                            </Typography>
                                          </TableCell>
                                          <TableCell align="center">
                                            <Typography
                                              noWrap={true}
                                              variant="subtitle2"
                                            >
                                              {getFormatoFecha(
                                                row.Desde,
                                                idioma
                                              )}
                                            </Typography>
                                          </TableCell>
                                          <TableCell align="center">
                                            <Typography
                                              noWrap={true}
                                              variant="subtitle2"
                                            >
                                              {getFormatoFecha(
                                                row.Hasta,
                                                idioma
                                              )}
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={30}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_12 &&
                              landing.anexo_12.length > 0 ? (
                                <Paper
                                  component={Paper}
                                  sx={{
                                    maxHeight: 1200,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                  }}
                                >
                                  <Typography
                                    variant="h5"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    La fracción arancelaria se encuentra listada
                                    en el Anexo 12 de las RGCE: Mercancías de
                                    las fracciones de la Tarifa de la Ley de los
                                    Impuestos Generales de Importación y de
                                    Exportación que procede su Exportación
                                    Temporal
                                  </Typography>
                                  <br />
                                  <Typography variant="h5">
                                    {React.createElement("div", {
                                      dangerouslySetInnerHTML: {
                                        __html: landing.anexo_12[0].Regla,
                                      },
                                    })}
                                  </Typography>
                                  <br />
                                  <Typography
                                    variant="p"
                                    sx={{ paddingTop: "15px" }}
                                  >
                                    <br />
                                    {`${messages.publicado}: ${getFormatoFecha(
                                      landing.anexo_12[0].Publicado,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.valido_desde
                                    }: ${getFormatoFecha(
                                      landing.anexo_12[0].Desde,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.validado_hasta
                                    }: ${getFormatoFecha(
                                      landing.anexo_12[0].Hasta,
                                      idioma
                                    )}`}

                                    <br />
                                  </Typography>
                                </Paper>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={31}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_14 &&
                              landing.anexo_14.length > 0 ? (
                                <Paper
                                  component={Paper}
                                  sx={{
                                    maxHeight: 600,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    display: "inline-table",
                                    overflow: "auto",
                                  }}
                                >
                                  <Typography
                                    variant="h5"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    La fracción arancelaria se encuentra listada
                                    en el Anexo 14 de las RGCE: Importación o
                                    exportación de hidrocarburos, productos
                                    petrolíferos, productos petroquímicos y
                                    azufre
                                  </Typography>
                                  <br />
                                  <Typography variant="h5">
                                    {React.createElement("div", {
                                      dangerouslySetInnerHTML: {
                                        __html: landing.anexo_14[0].Regla,
                                      },
                                    })}
                                  </Typography>
                                  <br />
                                  <Typography
                                    variant="p"
                                    sx={{ paddingTop: "15px" }}
                                  >
                                    <br />
                                    {`${messages.publicado}: ${getFormatoFecha(
                                      landing.anexo_14[0].Publicado,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.valido_desde
                                    }: ${getFormatoFecha(
                                      landing.anexo_14[0].Desde,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.validado_hasta
                                    }: ${getFormatoFecha(
                                      landing.anexo_14[0].Hasta,
                                      idioma
                                    )}`}

                                    <br />
                                  </Typography>
                                </Paper>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={32}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_17 &&
                              landing.anexo_17.length > 0 ? (
                                <Paper
                                  component={Paper}
                                  sx={{
                                    maxHeight: 600,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    display: "inline-table",
                                    overflow: "auto",
                                  }}
                                >
                                  <Typography
                                    variant="h5"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    La fracción arancelaria se encuentra listada
                                    en el Anexo 17 de las RGCE: Mercancías por
                                    las que no procederá el tránsito
                                    internacional por territorio nacional
                                  </Typography>
                                  <br />
                                  <Typography variant="h5">
                                    {landing.anexo_17[0].Descripcion}
                                    {"  "}
                                    {landing.anexo_17[0].Unicamente}
                                  </Typography>
                                  <br />
                                  <Typography
                                    variant="p"
                                    sx={{ paddingTop: "15px" }}
                                  >
                                    <br />
                                    {`${messages.publicado}: ${getFormatoFecha(
                                      landing.anexo_17[0].Publicado,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.valido_desde
                                    }: ${getFormatoFecha(
                                      landing.anexo_17[0].Desde,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.validado_hasta
                                    }: ${getFormatoFecha(
                                      landing.anexo_17[0].Hasta,
                                      idioma
                                    )}`}

                                    <br />
                                  </Typography>
                                </Paper>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={33}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_21 &&
                              landing.anexo_21.length > 0 ? (
                                <React.Fragment>
                                  <Paper
                                    component={Paper}
                                    sx={{
                                      maxHeight: 500,
                                      textAlign: "justify",
                                      padding: "30px 50px",
                                      display: "inline-table",
                                      overflow: "auto",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    <Typography
                                      variant="h5"
                                      sx={{ fontWeight: "bold" }}
                                    >
                                      La fracción arancelaria se encuentra
                                      listada en el Anexo 21 de las RGCE:
                                      Aduanas autorizadas para tramitar el
                                      despacho aduanerode determinado tipo de
                                      mercancías.
                                    </Typography>
                                    <br />
                                    <Typography variant="h5">
                                      {landing.anexo_21[0].TextoInciso}
                                    </Typography>
                                    <br />
                                    <Typography variant="h5">
                                      {landing.anexo_21[0].TextoNumeral}
                                      {"  "}
                                      {landing.anexo_21[0].Unicamente}
                                    </Typography>
                                    <br />
                                    <Typography
                                      variant="h5"
                                      sx={{ paddingTop: "15px" }}
                                    >
                                      {`${
                                        messages.publicado
                                      }: ${getFormatoFecha(
                                        landing.anexo_21[0].Publicado,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.valido_desde
                                      }: ${getFormatoFecha(
                                        landing.anexo_21[0].Desde,
                                        idioma
                                      )}`}
                                      <br />
                                      {`${
                                        messages.validado_hasta
                                      }: ${getFormatoFecha(
                                        landing.anexo_21[0].Hasta,
                                        idioma
                                      )}`}

                                      <br />
                                    </Typography>
                                  </Paper>

                                  <TableContainer
                                    component={Paper}
                                    sx={{ maxHeight: 500 }}
                                  >
                                    <Table
                                      stickyHeader
                                      aria-label="sticky table"
                                    >
                                      <TableHead>
                                        <TableRow>
                                          <TableCell align="center">
                                            Clave
                                          </TableCell>
                                          <TableCell align="center">
                                            Aduana
                                          </TableCell>
                                          <TableCell align="center">
                                            Nota
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {landing.anexo_21_tres &&
                                          landing.anexo_21_tres.map(
                                            (row, i) => (
                                              <TableRow hover={true} key={i}>
                                                <TableCell align="center">
                                                  {row.Aduana}
                                                </TableCell>
                                                <TableCell align="center">
                                                  {row.Texto}
                                                </TableCell>
                                                <TableCell align="center">
                                                  {row.Notas}
                                                </TableCell>
                                              </TableRow>
                                            )
                                          )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </React.Fragment>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={34}
                          dir={theme.direction}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ marginTop: "10px" }}
                          >
                            <Grid item xs={12} sx={{ textAlign: "start" }}>
                              {landing &&
                              landing.anexo_28 &&
                              landing.anexo_28.length > 0 ? (
                                <Paper
                                  component={Paper}
                                  sx={{
                                    maxHeight: 600,
                                    textAlign: "justify",
                                    padding: "30px 50px",
                                    display: "inline-table",
                                    overflow: "auto",
                                  }}
                                >
                                  <Typography
                                    variant="h5"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    La fracción arancelaria se encuentra listada
                                    en el Anexo 28 de las RGCE: Importación de
                                    mercancías sensibles por empresas que
                                    cuenten con el Registro en el Esquema de
                                    Certificación de Empresas.
                                  </Typography>
                                  <br />
                                  <Typography variant="h5">
                                    {landing.anexo_28[0].Descripcion}
                                  </Typography>
                                  <br />
                                  <Typography variant="h5">
                                    {`${landing.anexo_28[0].Inciso}) ${landing.anexo_28[0].Titulo} `}
                                  </Typography>
                                  <br />
                                  <Typography
                                    variant="p"
                                    sx={{ paddingTop: "15px" }}
                                  >
                                    <br />
                                    {`${messages.publicado}: ${getFormatoFecha(
                                      landing.anexo_28[0].Publicado,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.valido_desde
                                    }: ${getFormatoFecha(
                                      landing.anexo_28[0].Desde,
                                      idioma
                                    )}`}
                                    <br />
                                    {`${
                                      messages.validado_hasta
                                    }: ${getFormatoFecha(
                                      landing.anexo_28[0].Hasta,
                                      idioma
                                    )}`}

                                    <br />
                                  </Typography>
                                </Paper>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </TabPanel>
                      </SwipeableViews>
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}
              </TabPanel>
              <TabPanel value={valueConsulta} index={1}>
                <Grid container direction="row" style={{ marginTop: "50px" }}>
                  <Grid
                    item
                    xs={12}
                    alignContent="center"
                    sx={{ marginBottom: "50px" }}
                  >
                    <LocalizationProvider
                      utils={DateFnsUtils}
                      locale={idioma === "es-MX" ? esLocale : enLocale}
                      dateAdapter={AdapterDateFns}
                    >
                      <MobileDatePicker
                        label="Periodo"
                        value={fechaTabla}
                        inputFormat={"dd/MMM/yyyy"}
                        onChange={handleChangeDateDos}
                        renderInput={(params) => (
                          <TextField {...params} sx={{ width: "80%" }} />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={12} className={classes.cardServicios}>
                    {landing.capitulos && landing.capitulos.length > 0 ? (
                      <TableContainer
                        component={Paper}
                        sx={{ maxHeight: isShort ? 440 : 1000 }}
                      >
                        <Table stickyHeader aria-label="collapsible table">
                          <TableHead className="no">
                            <TableRow>
                              <TableCell />
                              <TableCell>{messages.seccion}</TableCell>
                              <TableCell align="left">
                                {messages.descripcion}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody className="no">
                            {landing &&
                              landing.secciones.map((row, i) => (
                                <Row
                                  key={i}
                                  row={row}
                                  capitulos={
                                    landing &&
                                    landing.capitulos.filter(
                                      (capitulo) =>
                                        capitulo.Seccion === row.Seccion
                                    )
                                  }
                                  partidas={landing.partidas}
                                  subpartidas={landing.subpartidas}
                                  fracciones={landing.fracciones}
                                  notas={landing.notas}
                                  nicos={landing.nicos}
                                  getPartida={getPartida}
                                  getSubpartida={getSubpartida}
                                  getFraccion={getFraccion}
                                  getNicos={getNicos}
                                  getNotas={getNotas}
                                  periodo={fechaTabla ? fechaTabla : new Date()}
                                  idioma={idioma}
                                  messages={messages}
                                  fechaTabla={fechaTabla}
                                />
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      <Stack spacing={1} sx={{ width: "100%" }}>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "65px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "65px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "65px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "65px" }}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          sx={{ height: "65px" }}
                        />
                      </Stack>
                    )}
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

Tarifa.propTypes = {
  classes: PropTypes.object.isRequired,
  messages: PropTypes.object.isRequired,
  servicios: PropTypes.object.isRequired,
  idioma: PropTypes.string.isRequired,
  theme: PropTypes.object,
  landing: PropTypes.object.isRequired,
  getBusqueda: PropTypes.func.isRequired,
  getCapitulos: PropTypes.func.isRequired,
  getSecciones: PropTypes.func.isRequired,
  getFraccion: PropTypes.func.isRequired,
  getSubpartida: PropTypes.func.isRequired,
  getPartida: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  getNicos: PropTypes.func.isRequired,
  getNotas: PropTypes.func.isRequired,
  getDescripcion: PropTypes.func.isRequired,
  getHistorico: PropTypes.func.isRequired,
  getTLCs: PropTypes.func.isRequired,
  getALADIs: PropTypes.func.isRequired,
  getFranja: PropTypes.func.isRequired,
  getProhibiciones: PropTypes.func.isRequired,
  getIndicadores: PropTypes.func.isRequired,
  getIndicadoresDos: PropTypes.func.isRequired,
  getArancelPais: PropTypes.func.isRequired,
  reiniciaBusqueda: PropTypes.func.isRequired,
  getPermisos: PropTypes.func.isRequired,
  getNoms: PropTypes.func.isRequired,
  getCuotasCompensatorias: PropTypes.func.isRequired,
  getImmex: PropTypes.func.isRequired,
  getPromocionSectorial: PropTypes.func.isRequired,
  getPreciosEstimados: PropTypes.func.isRequired,
  getArancelCupo: PropTypes.func.isRequired,
  getIva: PropTypes.func.isRequired,
  getIsan: PropTypes.func.isRequired,
  getIeps: PropTypes.func.isRequired,
  getPacic: PropTypes.func.isRequired,
  get_mercancia_peligrosa: PropTypes.func.isRequired,
  get_control_de_exportaciones: PropTypes.func.isRequired,
  get_medidas_de_transicion: PropTypes.func.isRequired,
  get_deposito_fiscal: PropTypes.func.isRequired,
  get_mercancias_vulnerables: PropTypes.func.isRequired,
  get_vehiculos_usados: PropTypes.func.isRequired,
  get_marcas_comerciales: PropTypes.func.isRequired,
  get_anexo_7: PropTypes.func.isRequired,
  get_anexo_8: PropTypes.func.isRequired,
  get_anexo_9: PropTypes.func.isRequired,
  get_anexo_29: PropTypes.func.isRequired,
  get_anexo_10: PropTypes.func.isRequired,
  get_anexo_12: PropTypes.func.isRequired,
  get_anexo_14: PropTypes.func.isRequired,
  get_anexo_17: PropTypes.func.isRequired,
  get_anexo_21: PropTypes.func.isRequired,
  get_anexo_28: PropTypes.func.isRequired,
  get_anexo_21_dos: PropTypes.func.isRequired,
  get_anexo_21_tres: PropTypes.func.isRequired,
  getIsanDos: PropTypes.func.isRequired,
  getPreciosEstimadosDos: PropTypes.func.isRequired,
  getPreciosEstimadosTres: PropTypes.func.isRequired,
  getCuposTLC: PropTypes.func.isRequired,
  getNotasTLC: PropTypes.func.isRequired,
  getCuposALADIDos: PropTypes.func.isRequired,
  getCuposALADIUno: PropTypes.func.isRequired,
  getCorrelativo: PropTypes.func.isRequired,
  handleScrollClick: PropTypes.func.isRequired,
  pushMessageToSnackbar: PropTypes.func,
};

const mapStateToProps = (state) => ({
  landing: state.landing,
  errors: state.errors,
});

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, {
    getBusqueda,
    getCapitulos,
    getCorrelativo,
    getSecciones,
    getNicos,
    getFraccion,
    getPartida,
    getSubpartida,
    getNotas,
    getDescripcion,
    getHistorico,
    getTLCs,
    getALADIs,
    getFranja,
    getProhibiciones,
    getIndicadores,
    getIndicadoresDos,
    getArancelPais,
    reiniciaBusqueda,
    getPermisos,
    getNoms,
    getCuotasCompensatorias,
    getImmex,
    getPromocionSectorial,
    getPreciosEstimados,
    getArancelCupo,
    getIva,
    getIsan,
    getIeps,
    getPacic,
    get_mercancia_peligrosa,
    get_control_de_exportaciones,
    get_medidas_de_transicion,
    get_deposito_fiscal,
    get_mercancias_vulnerables,
    get_vehiculos_usados,
    get_marcas_comerciales,
    get_anexo_7,
    get_anexo_8,
    get_anexo_9,
    get_anexo_29,
    get_anexo_10,
    get_anexo_12,
    get_anexo_14,
    get_anexo_17,
    get_anexo_21,
    get_anexo_28,
    get_anexo_21_dos,
    get_anexo_21_tres,
    getIsanDos,
    getPreciosEstimadosDos,
    getPreciosEstimadosTres,
    getCuposTLC,
    getNotasTLC,
    getCuposALADIDos,
    getCuposALADIUno,
  })(Tarifa)
);
